import dayjs from 'dayjs';
import autoTable from 'jspdf-autotable';
import ReportCoreMixin from '@shared_mixins/report/report.core.mixin.js';
import {benchmark_score} from '@shared/mixin/report/raw-data/kia-2025';

export default {
    mixins: [
        ReportCoreMixin
    ],
    data() {
        return {
            workerPieChartInstance: null,
            subsCompositionPieChartInstance: null,
            imporanceCompositionPieChartInstance: null,
            category1AreaChartInstance: null,
            category1PieChartInstance: null,
            category1ContraryAreaChartInstance: null,
            category1_composition_colors: [
                [117, 117, 117, 1],
                [165, 164, 164, 1],
                [125, 168, 178, 1],
                [71, 97, 123, 1]
                // [27, 50, 88, 1],
            ],
            importance_composition_colors: [
                [69, 90, 100, 1],
                [96, 125, 139, 1],
                [144, 164, 174, 1],
            ]
            // category1AreaChartInstance: null
        };
    },
    computed: {
        benchMarkScoreLabel() {
            return (type) => {
                let title = '';
                if ([514].includes(this.reportData?.info?.campaign.id)) {
                    title = this.report_lang === 'ko' ? '국내' : 'Domestic';
                } else if ([515, 516].includes(this.reportData?.info?.campaign.id)) {
                    title = this.report_lang === 'ko' ? '생산법인' : 'Prod. Site';
                } else if ([517, 519].includes(this.reportData?.info?.campaign.id)) {
                    title = this.report_lang === 'ko' ? '권역본부' : 'Regional HQ';
                } else if ([518].includes(this.reportData?.info?.campaign.id)) {
                    title = this.report_lang === 'ko' ? '국내 판매' : 'Sales HQ';
                } else if ([520].includes(this.reportData?.info?.campaign.id)) {
                    title = this.report_lang === 'ko' ? '해외 판매' : 'NSC';
                } else if ([521].includes(this.reportData?.info?.campaign.id)) {
                    title = this.report_lang === 'ko' ? '출고/서비스' : 'Delivery/Service';
                } else {
                    title = this.report_lang === 'ko' ? '유럽법인' : 'European Site';
                }
                title += type === 'avg' ? ` ${this.$t('평균', this.report_lang)}` : ` ${this.$t('최고', this.report_lang)}`;
                return title;
            };
        },
        benchMarkScore() {
            return benchmark_score[this.reportData?.info?.campaign.id ?? 'default'];
        },
        _jsPDF_headerStyles() {
            return {
                fontSize: 8.5,
                fillColor: [152, 74, 89],
                textColor: [255, 255, 255]
            };
        },
        tableStyles() {
            return {
                global: {
                    valign: 'middle',
                    overflow: 'linebreak',
                    lineColor: [222, 226, 230],
                    lineWidth: 0.1,
                    minCellHeight: 16,
                },
                th: {
                    // fontSize: this.report_lang === "ko" ? 11 : 10,
                    // fontSize: this.report_lang === "ko" ? 11 : 10.5,
                    fontSize: this.report_lang === 'ko' ? 9.5 : 9,
                    font: this.report_lang !== 'ca' ? 'NotoSansKR' : 'NotoSansHK',
                    cellPadding: {top: 4, bottom: 3, left: 3, right: 4},
                    fontStyle: 'medium',
                    fillColor: [246, 243, 242],
                    lineColor: [228, 220, 211],
                    textColor: '#292828', // "#424242"
                    valign: 'middle'
                },
                td: {
                    font: this.report_lang !== 'ca' ? 'NotoSansKR' : 'NotoSansHK',
                    // fontSize: this.report_lang === "ko" ? 9.5 : 9.0,
                    // fontSize: this.report_lang === "ko" ? 9.5 : 9,
                    fontSize: this.report_lang === 'ko' ? 8.5 : 8,
                    cellPadding: {top: 4, bottom: 3, left: 3, right: 4},
                    fontStyle: 'normal',
                    fillColor: '#FFFFFF', // [256, 256, 256],
                    // textColor: "#424242", // "#616161",
                    valign: 'middle'
                }
            };
        },
        _jsPDF_card_config() {
            return {
                fillColor: [246, 243, 242], // '#F8F8F8',
                borderColor: '#e4dcd3', // '#E0E0E0',
                lineWidth: 0.5
            };
        },
        headerInfo() {
            return {
                request_id: this.reportData?.info?.id,
                company_id: this.reportData?.info?.company.id,
                company_name: this.reportData?.info?.company?.company_name,
                vendor_code: this.reportData?.info?.vendor_code,
                published_date: this.reportData?.info?.completed_ts
            };
        },
        category1_description() {
            return {
                '3. 환경': this.$t('환경경영 평가는 환경정책을 수립하고 이에 따른 실천 목표와 세부 계획을 제시하고 있는지, 에너지 사용 및 온실가스 배출량 감축 등 성과를 주기적으로 모니터링하고 보고하는지 확인합니다.', this.report_lang),
                '1. 인권 및 노동': this.$t('인권경영 평가는 조직이 근로시간 관리, 차별 및 직장 내 괴롭힘 방지, 아동노동 및 강제노동 금지 등 인권을 보장하고 있는지, 또한 복지 및 역량강화 기회 등을 제공하고 있는지 확인합니다.', this.report_lang),
                '2. 윤리': this.$t('윤리경영 평가는 기업이 투명하고 윤리적인 경영체계를 구축하고, 부패나 뇌물수수, 반경쟁 행위 등 비윤리적 행위를 관리·감독하며, 재발 방지를 위한 조치를 취하고 있는지 확인합니다.', this.report_lang),
                '4. 안전': this.$t('안전보건경영 평가는 기업이 산업재해 예방, 안전보건 교육, 작업장 위험성 평가 등을 통해 안전 리스크를 줄이고, 임직원의 건강과 복지 증진 활동을 체계적으로 추진하고 있는지 확인합니다.', this.report_lang)
            };
        },
        scoringInfo() {
            let _total_score = this.scoring.total_scoring_pd[0];
            _total_score['환산_점수'] = this.roundToOneDecimalPlace(_total_score['환산_점수']);

            let _category1_score = [];
            if (this.scoring?.category1_scoring_pd) {
                _category1_score = this.orderCategory1(this.scoring?.category1_scoring_pd, 'category1_question_name').reduce((_category1_score, _category1) => {
                    const _question_name = this.report_lang === 'ko'
                        ? _category1['category1_question_name']
                        : this.report_lang === 'en'
                            ? _category1['category1_question_name_ea']
                            : _category1['category1_question_name_ca'];

                    _category1_score.push({
                        question_name: _question_name,
                        question_name_ko: _category1['category1_question_name'],
                        '문항_수': _category1['문항 수'] || 0,
                        '배점': _category1['배점'] || 0,
                        '배점_대비_점수_백분율': _category1['배점_대비_점수_백분율'] || 0,
                        '배점_합': _category1['배점_합'] || 0,
                        '가중치': this.roundToOneDecimalPlace(_category1['가중치'] || 0),
                        '접수_합': this.roundToOneDecimalPlace(_category1['score'] || 0),
                        '환산_점수': this.roundToOneDecimalPlace(_category1['환산_점수'] || 0)
                    });
                    return _category1_score;
                }, []);
            }

            let _category3_score = [];
            if (this.scoring?.category3_scoring_pd) {
                _category3_score = this.scoring?.category3_scoring_pd.reduce((_category3_score, _category3) => {
                    const _category3_sub_scoring = this.scoring.sub_scoring_pd.filter((_category3_sub) => _category3_sub.category3_question_code === _category3.category3_question_code);

                    let _is_category3_na = false;
                    if (_category3_sub_scoring.length) {
                        _is_category3_na = _category3_sub_scoring.every(({not_applicable}) => not_applicable === true);
                    }

                    if (!_category3_score[_category3.category1_question_name]) {
                        const _category3_category1_score = this.scoring?.category1_scoring_pd.find(({category1_question_name}) => category1_question_name === _category3.category1_question_name);
                        // let { category1_question_code, category1_question_name, category1_question_name_ca, category1_question_name_ea, not_applicable_num, 환산_점수 } = _category3
                        let {
                            category1_question_code,
                            category1_question_name,
                            category1_question_name_ca,
                            category1_question_name_ea
                        } = _category3;
                        환산_점수 = _is_category3_na ? null : this.roundToOneDecimalPlace(환산_점수 || 0);

                        _category3_score[_category3.category1_question_name] = {
                            category1_question_code,
                            category1_question_name_ko: category1_question_name,
                            category1_question_name: this.report_lang === 'ko'
                                ? category1_question_name
                                : this.report_lang === 'ca' ? category1_question_name_ca : category1_question_name_ea,
                            category1_score: this.roundToOneDecimalPlace(_category3_category1_score['환산_점수']),
                            min: this.roundToOneDecimalPlace(_category3_category1_score['환산_점수']),
                            max: null,
                            category3: []
                        };
                    }

                    let {
                        category3_question_code,
                        category3_question_name,
                        category3_question_name_ca,
                        category3_question_name_ea,
                        환산_점수
                    } = _category3;

                    if (!_is_category3_na) {
                        환산_점수 = this.roundToOneDecimalPlace(환산_점수);
                        if (환산_점수 > 0) {
                            _category3_score[_category3.category1_question_name]['max'] = Math.max(_category3_score[_category3.category1_question_name]['max'], 환산_점수);
                        }
                        // _category3_score[_category3.category1_question_name]["max"] = Math.max(_category3_score[_category3.category1_question_name]["max"], 환산_점수)
                        _category3_score[_category3.category1_question_name]['min'] = Math.min(_category3_score[_category3.category1_question_name]['min'], 환산_점수);
                    }

                    _category3_score[_category3.category1_question_name].category3.push({
                        category3_question_code,
                        category3_question_name_kr: category3_question_name,
                        category3_question_name: this.report_lang === 'ko'
                            ? category3_question_name
                            : this.report_lang === 'ca' ? category3_question_name_ca : category3_question_name_ea,
                        score: _is_category3_na ? null : this.roundToOneDecimalPlace(환산_점수 || 0),
                        not_applicable: _is_category3_na
                    });
                    return _category3_score;
                }, {});

                const parseKey = str => str.split('.')[0] * 10000 + str.split('.')[1] * 100 + str.split('.')[2];

                Object.values(_category3_score).forEach((_category3_group) => {
                    _category3_group.min = _category3_group.max === _category3_group.min ? null : _category3_group.min;
                    _category3_group.category3.forEach(category3_ele => {
                        category3_ele.max = category3_ele.score === _category3_group.max;
                        category3_ele.min = category3_ele.score === _category3_group.min;
                    });
                    _category3_group.category3 = _category3_group.category3.sort((a, b) => parseKey(a.category3_question_name) - parseKey(b.category3_question_name));

                    _category3_group.min = _category3_group.min === null ? ' - ' : _category3_group.min;
                });
            }

            const _category3 = this.orderCategory1(Object.values(_category3_score), 'category1_question_name_ko');
            return {
                total: _total_score,
                category1: _category1_score,
                category3: _category3
            };
        },
        evaluation_score_description() {
            return {
                'ko': `${this.companyInfo['회사명']} 의 ${this.cover_title} 총점은 ${this.roundToOneDecimalPlace(this.scoringInfo.total['환산_점수'])} 점 입니다.`,
                'en': `The total score of the ${this.cover_title} for ${this.companyInfo['회사명']} is ${this.roundToOneDecimalPlace(this.scoringInfo.total['환산_점수'])} points.`,
                'ca': `${this.companyInfo['회사명']} 在 ${this.cover_title}中的总分为 ${this.roundToOneDecimalPlace(this.scoringInfo.total['환산_점수'])} 分。`
            };
        },
        companyInfo() {
            if (!this.reportData?.parser.values.length) {
                return {
                    '소재국가': ' - ',
                    '매출액': ' - ',
                    '근로자수': ' - ',
                    '근로자_정규직': ' - ',
                    '근로자_계약직': ' - ',
                    '근로자_일용직': ' - ',
                    '근로자_사내도급': ' - '
                };
            } else {
                const _company_info_field = ['소재국가', '매출액', '근로자수', '근로자_정규직', '근로자_계약직', '근로자_일용직', '근로자_사내도급'];
                const _company_info = [...this.reportData?.parser.values].reduce((_info, _value) => {
                    if (_company_info_field.includes(_value.criteria_name)) {
                        _info[_value.criteria_name] = !_value.value.length
                            ? '(없음)'
                            : _value.value[0];
                    } else {
                        _info[_value.criteria_name] = ' - ';
                    }

                    return _info;
                }, {});

                const _company_info_exist_keys = Object.keys(_company_info);
                _company_info_field.forEach(_field => {
                    if (!_company_info_exist_keys.includes(_field)) {
                        _company_info[_field] = ' - ';
                    }
                });

                _company_info['회사명'] = this.reportData.info.company.company_name;
                _company_info['사업장 유형'] = this.reportData.info.company.hd_corporate;

                return _company_info;
            }
        },
        assessmentInfo() {
            let {
                service_type,
                requested_ts,
                in_progress_ts,
                in_assessment_ts,
                duedate_ts,
                completed_ts
            } = this.reportData.info;
            service_type = service_type === '일반' ? this.$t('일반 평가', this.report_lang) : this.$t('심화 평가', this.report_lang);

            let _assessmentInfo = {
                service_type: null, requested_date: requested_ts, duedate_date: duedate_ts, completed_date: completed_ts
            };

            if (service_type) _assessmentInfo.service_type = this.$t(service_type, this.report_lang);

            // 평가기간 실 평가기간으로 교체
            if (this.set_actual_duration) {
                _assessmentInfo.requested_date = this.report_lang === 'ko'
                    ? dayjs(in_progress_ts).format('YYYY년 MM월 DD일')
                    : dayjs(in_progress_ts).format('MM/DD/YYYY');

                _assessmentInfo.duedate_date = this.report_lang === 'ko'
                    ? dayjs(in_assessment_ts).format('YYYY년 MM월 DD일')
                    : dayjs(in_assessment_ts).format('MM/DD/YYYY');
            } else {
                if (_assessmentInfo.requested_date) {
                    _assessmentInfo.requested_date = this.report_lang === 'ko'
                        ? dayjs('2024-03-29').format('YYYY년 MM월 DD일')
                        : dayjs('2024-03-29').format('MM/DD/YYYY');
                } else {
                    _assessmentInfo.requested_date = ' - ';
                }

                if (_assessmentInfo.duedate_date) {
                    _assessmentInfo.duedate_date = this.report_lang === 'ko'
                        ? dayjs(_assessmentInfo.duedate_date).format('YYYY년 MM월 DD일')
                        : dayjs(_assessmentInfo.duedate_date).format('MM/DD/YYYY');
                } else {
                    _assessmentInfo.duedate_date = ' - ';
                }

                if (_assessmentInfo.completed_date) {
                    _assessmentInfo.completed_date = this.report_lang === 'ko'
                        ? dayjs(_assessmentInfo.completed_date).format('YYYY년 MM월 DD일')
                        : dayjs(_assessmentInfo.completed_date).format('MM/DD/YYYY');
                } else {
                    _assessmentInfo.completed_date = dayjs().format(this.report_lang === 'ko' ? 'YYYY년 MM월 DD일' : 'MM/DD/YYYY');
                }
            }

            return _assessmentInfo;
        },
        ordered_cataory1() {
            return ['1. 인권 및 노동', '2. 윤리', '3. 환경', '4. 안전'];
        },
        category1_composition() {
            if (!this.scoring?.scoring_pd || !this.scoring.scoring_pd.length) {
                return [
                    {label: '인권', value: 0},
                    {label: '윤리', value: 0},
                    {label: '환경', value: 0},
                    {label: '안전', value: 0},
                ];
            } else {
                const _category1_composition = [...this.scoring.scoring_pd, ...this.reportData.risk.risk_pd].reduce((_cat1_composition, _score) => {
                    const {
                        satisfied,
                        category1_question_code,
                        category1_question_name,
                        category1_question_name_ca,
                        category1_question_name_ea,
                        sub_code
                    } = _score;
                    if (!_cat1_composition[category1_question_code]) {
                        _cat1_composition[category1_question_code] = {
                            category1_question_name, category1_question_name_ca, category1_question_name_ea,
                            subs: [], count: 0
                        };
                    }

                    if (!_cat1_composition[category1_question_code]['subs'].includes(sub_code)) {
                        _cat1_composition[category1_question_code]['subs'].push(sub_code);
                        _cat1_composition[category1_question_code]['count'] += 1;
                    }

                    return _cat1_composition;
                }, {});

                return this.ordered_cataory1.reduce((_ordered, _category1_name) => {
                    const _category1 = Object.values(_category1_composition).find(({category1_question_name}) => category1_question_name === _category1_name);
                    if (_category1) _ordered.push(_category1);
                    return _ordered;
                }, []);
            }
        },
        importance_composition() {
            if (!this.scoring?.scoring_pd || !this.scoring.scoring_pd.length) {
                return {'HIGH': 0, 'MEDIUM': 0, 'LOW': 0};
            } else {
                const _importance_composition = this.scoring.scoring_pd.reduce((_cat1_composition, _score) => {
                    const {satisfied, not_applicable, ev_importance} = _score;
                    if (!_cat1_composition[ev_importance]) {
                        _cat1_composition[ev_importance] = 0;
                    }

                    if (satisfied && !not_applicable) ++_cat1_composition[ev_importance];

                    return _cat1_composition;
                }, {'HIGH': 0, 'MEDIUM': 0, 'LOW': 0});

                return _importance_composition;
            }
        },
        risk_composition() {
            if (!this.reportData?.risk?.risk_pd || !this.reportData.risk.risk_pd.length) {
                return [
                    {label: '인권', item: []},
                    {label: '윤리', item: []},
                    {label: '환경', item: []},
                    {label: '안전', item: []}
                ];
            } else {
                const _risk_composition = this.reportData?.risk?.risk_pd
                    .filter(({risk}) => risk)
                    .reduce((_cat1_composition, _score) => {
                        const {
                            satisfied,
                            not_applicable,
                            category1_question_code,
                            category1_question_name,
                            category1_question_name_ca,
                            category1_question_name_ea
                        } = _score;
                        if (!_cat1_composition[category1_question_code]) {
                            _cat1_composition[category1_question_code] = {
                                category1_question_name, category1_question_name_ca, category1_question_name_ea,
                                item: []
                            };
                        }

                        if (satisfied && !not_applicable) {
                            _cat1_composition[category1_question_code]['item'].push(_score);
                        }

                        return _cat1_composition;
                    }, {});

                return Object.values(_risk_composition).reduce((_risk_composition, _risk) => {
                    if (_risk.item && _risk.item.length) {
                        _risk.item = this.sortBySubCode(_risk.item);
                    }
                    _risk_composition.push(_risk);
                    return _risk_composition;
                }, []);
            }
        },
        compliance_composition() {
            if (!this.scoring?.scoring_pd || !this.scoring.scoring_pd.length) {
                return [
                    {label: '인권', item: []},
                    {label: '윤리', item: []},
                    {label: '환경', item: []},
                    {label: '안전', item: []}
                ];
            } else {
                const _compliance_composition = this.scoring?.scoring_pd
                    .filter(({is_compliance}) => is_compliance === 1)
                    .reduce((_cat1_composition, _score) => {
                        const {
                            satisfied,
                            not_applicable,
                            category1_question_code,
                            category1_question_name,
                            category1_question_name_ca,
                            category1_question_name_ea
                        } = _score;
                        if (!_cat1_composition[category1_question_code]) {
                            _cat1_composition[category1_question_code] = {
                                category1_question_name, category1_question_name_ca, category1_question_name_ea,
                                item: []
                            };
                        }

                        if (!satisfied && !not_applicable) {
                            _cat1_composition[category1_question_code]['item'].push(_score);
                        }

                        return _cat1_composition;
                    }, {});

                return Object.values(_compliance_composition);
            }
        },
        sub_imporatance_composition_description() {
            let _cat1_question_name_key = {
                'ko': 'category1_question_name',
                'ca': 'category1_question_name_ca',
                'en': 'category1_question_name_ea'
            };
            const total_subs = Object.values(this.category1_composition).reduce((_total_subs, _sub_count) => (_total_subs += _sub_count.count), 0);
            let cat1_subs_desc = this.category1_composition.reduce((_cat1_subs_desc, _cat1_subs) => {
                _cat1_subs_desc.push(`${_cat1_subs[_cat1_question_name_key[this.report_lang]]} - ${_cat1_subs.count} ${this.report_lang === 'ko' ? ' 개' : ' indicators'}`);
                return _cat1_subs_desc;
            }, []).join(', ');

            let cat1_subs_max = this.category1_composition.reduce((_cat1_subs_statics, _cat1_subs) => {
                if (_cat1_subs_statics.count <= _cat1_subs.count) {
                    if (_cat1_subs_statics.count === _cat1_subs.count) {
                        _cat1_subs_statics.category_name.push(_cat1_subs[_cat1_question_name_key[this.report_lang]]);
                    } else if (_cat1_subs_statics.count < _cat1_subs.count) {
                        _cat1_subs_statics.category_name = [_cat1_subs[_cat1_question_name_key[this.report_lang]]];
                    }

                    _cat1_subs_statics.count = _cat1_subs.count;
                    _cat1_subs_statics.share = ((_cat1_subs.count / total_subs) * 100).toFixed(1);
                }

                return _cat1_subs_statics;
            }, {category_name: [], count: 0, share: 0});

            let importance_total = Object.values(this.importance_composition).reduce((_importance_sum, _importance_count) => (_importance_sum += _importance_count), 0);
            let importance_max = Object.entries(this.importance_composition).reduce((_importance_statics, [_importance_key, _importance_count]) => {
                if (_importance_statics.count <= _importance_count) {
                    if (_importance_statics.count === _importance_count) {
                        _importance_statics.category_name.push(_importance_key);
                    } else if (_importance_statics.count < _importance_count) {
                        _importance_statics.category_name = [_importance_key];
                    }

                    _importance_statics.count = _importance_count;
                    _importance_statics.share = ((_importance_count / importance_total) * 100).toFixed(1);
                }

                return _importance_statics;
            }, {category_name: [], count: -1, share: 0});

            let _composition_description = null;
            if (this.report_lang === 'ko') {
                _composition_description = `  ${this.reportData?.info?.company?.company_name}의 서면진단 점수는 총 ${total_subs}개의 지표에 대한 응답을 평가하여 도출하였습니다.`;
                _composition_description += `진단 질문지는 영역별로 ${cat1_subs_desc}로 구성되며, "${cat1_subs_max.category_name.join(',')}" 영역의 지표가 ${cat1_subs_max.share} %로 가장 높은 비중을 차지합니다.`;
                _composition_description += '\n  모든 지표는 HIGH, MID, LOW의 중요도를 기준으로 구분되며, 중요도가 높을수록 높은 배점을 부여하였습니다. ';
                _composition_description += `중요도 구성 중 높은 비중을 차지한 중요도는 "${importance_max.category_name.join(', ')}" 지표로, 전체의 ${importance_max.share} %로 ${importance_max.count} 개 입니다.`;
            } else if (this.report_lang === 'en') {
                _composition_description = `The online assessment score for ${this.reportData?.info?.company?.company_name} was derived based on responses to a total of ${total_subs} indicators across the following 4 areas: ${cat1_subs_desc}. `;
                _composition_description += `Among these, ${cat1_subs_max.category_name.join(', ')} category accounts for the highest proportion, constituting ${cat1_subs_max.share}% of all indicators. `;
                _composition_description += 'Each indicator is classified according to its level of importance: HIGH, MID, or LOW. ';
                _composition_description += 'The higher the importance, the greater the assigned weight. ';
                _composition_description += `Among these classifications, the most frequently occurring level of importance is "${importance_max.category_name.join(', ')}", which comprises ${importance_max.share}% of the total, or ${importance_max.count} indicators.`;
            } else {
                _composition_description = `  ${this.reportData?.info?.company?.company_name}的书面评估得分是根据对${total_subs}个指标的答复进行评估得出的。`;
                _composition_description += `诊断问卷按领域分为：${cat1_subs_desc}，其中“${cat1_subs_max.category_name.join(',')}”领域的指标占比最高，为${cat1_subs_max.share}%。`;
                _composition_description += '\n  所有指标按 HIGH、MID、LOW 的重要等级进行分类，重要性越高，分值越高。';
                _composition_description += `在重要度构成中，占比较高的是“${importance_max.category_name.join(', ')}”等级，占总数的${importance_max.share}%，共${importance_max.count}项。`;
            }
            return _composition_description;
        },
        risk_description() {
            if (this.report_lang === 'ko') {
                return '\'잠재적 리스크 노출\'은 사업장의 근본적인 운영 환경 및 조건으로 인한 인권·윤리·환경·안전 영역에서의 잠재적인 위험 요소를 나타내는 것으로, 도출된 리스크는 사업장의 관리 수준과 무관한 본질적인 특성에 가깝습니다. 아래 나열된 리스크 요소를 통해 사업장의 특성을 이해하고, 지속적인 모니터링과 활동으로 리스크 요소를 관리해야 합니다.';
            } else if (this.report_lang === 'en') {
                return '\'Potential Risk  Exposure\' refers to potential risk factors in the areas of human rights, ethics, environment, and safety that arise from the fundamental operational environment and conditions of a business site. Thus, identified risks closely represent the inherent characteristics of the business site, independent of the management level. Understanding the risk factors listed below provides insight into the workplace characteristics, and continuous monitoring and activities are necessary to manage these risk elements.';
            } else {
                return '“风险敞口”是指企业基本经营环境和条件所造成的风险。人权、道德、环境和安全领域的潜在风险因素如图所示，所衍生的风险与企业机构的管理水平无关。更接近本质特征。通过下面列出的风险因素：了解工作场所的特点并持续监测和活动需要管理风险因素。';
            }
        },
        compliance_description() {
            if (this.report_lang === 'ko') {
                return '\'컴플라이언스 이슈\'는 규제 위반 및 법적 리스크와 관련된 사항으로, 컴플라이언스 이슈가 있을 경우 재발 방지를 위해 해당 영역의 관리 수준을 높여야 합니다.';
            } else if (this.report_lang === 'en') {
                return '\'Compliance issues\' refer to matters related to regulatory violations and legal risks. In cases where a business site possesses compliance issues, it is imperative to elevate the management level in the relevant area to prevent recurrence.';
            } else {
                return '‘潜在风险暴露’与监管违规和法律风险有关。如果存在合规问题，就必须提高该领域的管理水平，以防止再次发生。';
            }
        },
        section_score_description() {
            const category1_scores_string = this.scoringInfo?.category1.reduce((_category1_scores_string, _category1) => {
                _category1_scores_string.push(`${_category1.question_name}: ${_category1['환산_점수']}${this.$t('점', this.report_lang)}`);
                return _category1_scores_string;
            }, []).join(', ');

            const lowest_score_category1 = this.scoringInfo?.category1.reduce((_lowest_score_category1, _category1) => {
                if (_lowest_score_category1.score >= Number(_category1['환산_점수'])) {
                    if (_lowest_score_category1.score < _category1['환산_점수']) {
                        _lowest_score_category1.question_name = [_category1['question_name']];
                    } else {
                        _lowest_score_category1.question_name.push(_category1['question_name']);
                    }

                    _lowest_score_category1.score = Number(_category1['환산_점수']);
                }

                return _lowest_score_category1;
            }, {question_name: [], score: 101});
            lowest_score_category1.question_name = lowest_score_category1.question_name.join(', ');

            let _section_score_description = '';
            if (this.report_lang === 'ko') {
                _section_score_description += `2025 기아 인권/환경 실사 서면진단은 인권, 윤리, 환경, 안전의 네 영역에서 각 사업장의 운영 체계 및 관리 실태 전반을 진단할 수 있도록 설계되었습니다. 분석 결과, ${this.reportData?.info?.company?.company_name}의 영역별 세부 점수는 `;
                _section_score_description += category1_scores_string;
                _section_score_description += `으로, 특히 ${lowest_score_category1.question_name} 영역에서의 관리 수준 향상이 필요합니다.`;
            } else if (this.report_lang === 'en') {
                _section_score_description += 'The 2025 Kia Business Site Human Rights & Environmental Due Diligence Online Assessment was designed to evaluate the overall operational systems and management practices of each site across four key areas: Human Rights & Labor, Ethics, Environment, and Safety. ';
                _section_score_description += `According to the analysis results, ${this.reportData?.info?.company?.company_name} received the following scores by area: `;
                _section_score_description += category1_scores_string;
                _section_score_description += `. In particular, there is a need for improvement in the management systems related to ${lowest_score_category1.question_name}.`;

            } else {
                _section_score_description += '2025年起亚事业场所人权与环境尽职调查线上评估，旨在从人权与劳工、伦理、环境、安全四个关键领域评估各场所的整体运营体系与管理实践。';
                _section_score_description += `根据分析结果，${this.reportData?.info?.company?.company_name} 在各领域的得分如下：`;
                _section_score_description += category1_scores_string;
                _section_score_description += `。特别是在与${lowest_score_category1.question_name}相关的管理体系方面，需要进一步改进。`;
            }

            return _section_score_description;
        }
    },
    methods: {
        async createSummaryPage(doc, position_y) {
            position_y = this.firstElementSpacing;
            position_y = this.addTitle(doc, position_y, 1, 'ESG 평가 결과 요약');

            // 기업정보 섹션
            position_y = this.addTitle(doc, position_y, 2, '사업장 및 평가 정보', {
                skip_divider: true,
                no_padding: true,
                no_margin: true
            });
            /**
             * 기업 기본정보: 사업장명, 소재국가, 매출액, 사업장 유형, 근로자수 (막대 차트)
             */

            let _column_width = this.pageContentWidth / 4;
            let [_assessment_info_table_styles_th, _assessment_info_table_styles_td] = [
                {...this.tableStyles.th, cellWidth: _column_width},
                {...this.tableStyles.td, cellWidth: _column_width}
            ];

            let _assessment_info_table_body = [
                [
                    {content: this.$t('평가기간', this.report_lang), styles: _assessment_info_table_styles_th},
                    {
                        content: `${this.assessmentInfo.requested_date} ~ ${this.assessmentInfo.duedate_date}`,
                        colSpan: 3,
                        styles: _assessment_info_table_styles_td
                    }
                ]
            ];

            if ((this.assessmentType && this.assessmentType === 'OSIS') || (!this.assessmentType && this.reportData.info.service_type === '심화')) {
                _assessment_info_table_body.push(
                    [
                        {content: this.$t('평가유형', this.report_lang), styles: _assessment_info_table_styles_th},
                        {
                            content: this.$t('실사평가', this.report_lang),
                            colSpan: 3,
                            styles: _assessment_info_table_styles_td
                        }
                    ]
                );
            }

            autoTable(doc, {
                theme: 'grid',
                startY: position_y,
                margin: this.jsPDFOpt.margin,
                styles: {...this.tableStyles.global},
                body: [
                    [
                        {content: this.$t('사업장명', this.report_lang), styles: _assessment_info_table_styles_th},
                        {content: this.companyInfo['회사명'], styles: _assessment_info_table_styles_td},
                        {content: this.$t('업체코드', this.report_lang), styles: _assessment_info_table_styles_th},
                        {content: this.headerInfo.vendor_code, styles: _assessment_info_table_styles_td}
                    ],
                    [
                        {content: this.$t('소재국가', this.report_lang), styles: _assessment_info_table_styles_th},
                        {content: this.companyInfo['소재국가'], styles: _assessment_info_table_styles_td},
                        {content: this.$t('사업장 유형', this.report_lang), styles: _assessment_info_table_styles_th},
                        {
                            content: this.$t(this.companyInfo['사업장 유형'], this.report_lang),
                            styles: _assessment_info_table_styles_td
                        }
                    ],
                    [
                        {content: this.$t('매출액', this.report_lang), styles: _assessment_info_table_styles_th},
                        {content: this.companyInfo['매출액'], colSpan: 3, styles: _assessment_info_table_styles_td}
                    ],
                    ..._assessment_info_table_body
                ],
                didDrawCell: (data) => this.jspdf_common_cell_font_convert(data)
            });

            position_y = doc.lastAutoTable.finalY + this.jsPDFOpt.spacing.section_xs;

            // 근로자수
            position_y = this.addTitle(doc, position_y, 3, this.$t('고용형태별 근로자 수', this.report_lang), {
                skip_divider: true,
                no_margin: true
            });
            const _worker_group = {
                '정규직': Number(this.companyInfo['근로자_정규직'].replace(/[^\d.]/g, '') || 0),
                '계약직': Number(this.companyInfo['근로자_계약직'].replace(/[^\d.]/g, '') || 0),
                '일용직 근로자': Number(this.companyInfo['근로자_일용직'].replace(/[^\d.]/g, '') || 0),
                '사내도급 근로자': Number(this.companyInfo['근로자_사내도급'].replace(/[^\d.]/g, '') || 0)
            };

            const _total_worker = Object.values(_worker_group).reduce((_total, _single) => (_total += _single), 0);
            const _worker_group_share = {
                '정규직': Number(((_worker_group['정규직'] / _total_worker) * 100)),
                '계약직': Number(((_worker_group['계약직'] / _total_worker) * 100)),
                '일용직 근로자': Number(((_worker_group['일용직 근로자'] / _total_worker) * 100)),
                '사내도급 근로자': Number(((_worker_group['사내도급 근로자'] / _total_worker) * 100)),
            };

            const _worker_box = 60;
            const _worker_box_padding = 10;
            const _worker_box_inner_width = (this.pageContentWidth - this.jsPDFOpt.margin.left + (_worker_box_padding * 2));

            doc.setLineWidth(0);
            doc.setDrawColor('#F8F8F8');
            doc.setFillColor(...this.jsPDFOpt.card.fillColor);
            doc.rect(this.jsPDFOpt.margin.left, position_y, this.pageContentWidth, _worker_box, 'FD');

            const _total_worker_label_position_x = this.jsPDFOpt.margin.left + _worker_box_padding;
            const _total_worker_label_position_y = position_y + _worker_box_padding;
            let _total_worker_position_y = this.addTitle(doc, _total_worker_label_position_y, 4,
                `${this.$t('총 근로자', this.report_lang)} : ${this.won_comma(_total_worker)}`,
                {skip_divider: true, no_margin: true, position_x: _total_worker_label_position_x}
            );

            const _total_worker_bar_position_x_start = _total_worker_label_position_x;
            const _total_worker_bar_width = this.report_lang !== 'en' ? _worker_box_inner_width * 0.8 : _worker_box_inner_width * 0.75;
            const _total_worker_bar_height = 10;
            const _worker_group_width = [
                {
                    type: this.$t('정규직', this.report_lang),
                    value: (_worker_group_share['정규직'] / 100) * _total_worker_bar_width,
                    share: _worker_group_share['정규직'],
                    fillColor: [69, 90, 100],
                    textColor: '#f1f1f1'
                },
                {
                    type: this.$t('계약직', this.report_lang),
                    value: (_worker_group_share['계약직'] / 100) * _total_worker_bar_width,
                    share: _worker_group_share['계약직'],
                    fillColor: [158, 158, 158],
                    textColor: '#f1f1f1'
                },
                {
                    type: this.$t('일용직 근로자', this.report_lang),
                    value: (_worker_group_share['일용직 근로자'] / 100) * _total_worker_bar_width,
                    share: _worker_group_share['일용직 근로자'],
                    fillColor: [141, 110, 99],
                    textColor: '#f1f1f1'
                },
                {
                    type: this.$t('사내도급 근로자', this.report_lang),
                    value: (_worker_group_share['사내도급 근로자'] / 100) * _total_worker_bar_width,
                    share: _worker_group_share['사내도급 근로자'],
                    fillColor: [161, 136, 127],
                    textColor: '#f1f1f1'
                }
            ];


            doc.setLineWidth(this.jsPDFOpt.card.lineWidth);
            doc.setDrawColor(this.jsPDFOpt.card.borderColor);
            doc.setFillColor(...this.jsPDFOpt.card.fillColor);
            _total_worker_position_y += 4; // 7.5
            doc.rect(_total_worker_bar_position_x_start, _total_worker_position_y, _total_worker_bar_width, _total_worker_bar_height, 'FD');

            // 수평 막대 차트 - 단위
            doc.setFontSize(7);
            const _worker_bar_unit = doc.splitTextToSize(`(${this.$t('단위', this.report_lang)}: %)`);
            const _worker_bar_unit_dim = doc.getTextDimensions(_worker_bar_unit, {fontSize: 7});
            let _worker_bar_unit_position_x = _total_worker_bar_position_x_start + _total_worker_bar_width - _worker_bar_unit_dim.w;
            let _worker_bar_unit_position_y = _total_worker_position_y - (_worker_bar_unit_dim.h * 0.75);
            doc.text(_worker_bar_unit, _worker_bar_unit_position_x, _worker_bar_unit_position_y);

            // 수평 막대 차트 - 차트 생성
            let _worker_bar_element_position_x = _total_worker_bar_position_x_start;
            let _worker_bar_legend_position_x = this.report_lang === 'ko'
                ? 100
                : this.report_lang === 'en' ? 60 : 100;

            _worker_group_width.forEach((_worker) => {
                if (_worker.value) {
                    doc.setFillColor(..._worker.fillColor);
                    doc.setTextColor(_worker.textColor);
                    doc.rect(_worker_bar_element_position_x, _total_worker_position_y, _worker.value, _total_worker_bar_height, 'F');

                    doc.setFontSize(9);
                    const _worker_datalabel = doc.splitTextToSize(_worker.share.toFixed(1));
                    const _worker_datalabel_dim = doc.getTextDimensions(_worker_datalabel, {fontSize: 9});

                    if (_worker.share >= _worker_datalabel_dim.w + 1) {
                        const _worker_datalabel_position_x = _worker_bar_element_position_x + ((_worker.value - _worker_datalabel_dim.w) / 2);
                        const _worker_datalabel_position_y = _total_worker_position_y + _worker_datalabel_dim.h + 0.75;
                        doc.text(_worker_datalabel, _worker_datalabel_position_x, _worker_datalabel_position_y);
                    }
                    _worker_bar_element_position_x += _worker.value;
                }

                const _worker_bar_legend_size = 7;
                const _worker_bar_legend_text_spacing = 3;
                const _worker_bar_legend_position_y = _total_worker_position_y + _total_worker_bar_height + 5;
                doc.setFillColor(..._worker.fillColor);
                doc.rect(_worker_bar_legend_position_x, _worker_bar_legend_position_y, _worker_bar_legend_size, _worker_bar_legend_size, 'F');

                _worker_bar_legend_position_x += _worker_bar_legend_size + _worker_bar_legend_text_spacing;
                doc.setFontSize(9);
                const _worker_legend_title = doc.splitTextToSize(_worker.type);
                const _worker_legend_title_dim = doc.getTextDimensions(_worker_legend_title, {fontSize: 9});

                doc.setTextColor(this.jsPDFOpt.fontColor.default);
                doc.text(_worker_legend_title, _worker_bar_legend_position_x, _worker_bar_legend_position_y + _worker_bar_legend_size - 1);

                _worker_bar_legend_position_x += _worker_legend_title_dim.w + 5;
            });

            // 수평 막대 - 범주

            // _total_worker_bar_width // 막대차트 너비
            const _total_worker_legend_position_top = this.report_lang === 'en' ? _total_worker_label_position_y - 6.5 : _total_worker_label_position_y - 4.0;
            const _total_worker_legend_position_left = (_total_worker_bar_position_x_start + _total_worker_bar_width) + _worker_box_padding;
            const _total_worker_legend_table_width = this.pageContentWidth - _total_worker_legend_position_left + this.jsPDFOpt.margin.left - _worker_box_padding; // (_worker_box_padding * 2)
            const _total_worker_legend_title_styles = {
                ...this.tableStyles.th,
                fontSize: 8,
                halign: 'right',
                fillColor: this.jsPDFOpt.card.fillColor,
                cellPadding: {top: 2.5, bottom: 2.5}
            };
            const _total_worker_legend_value_styles = {
                ...this.tableStyles.td,
                fontSize: 8,
                halign: 'left',
                fillColor: this.jsPDFOpt.card.fillColor,
                cellPadding: {top: 2.5, bottom: 2.5, right: 0, left: 3}
            };
            autoTable(doc, {
                theme: 'grid',
                startY: _total_worker_legend_position_top,
                tableWidth: _total_worker_legend_table_width,
                margin: {...this.jsPDFOpt.margin, top: 0, left: _total_worker_legend_position_left},
                styles: {...this.tableStyles.global, minCellHeight: 8, fontSize: 7, lineWidth: 0},
                body: [
                    [
                        {'content': `${this.$t('정규직', this.report_lang)}:`, styles: _total_worker_legend_title_styles},
                        {
                            'content': this.report_lang !== 'ko' ? this.won_comma(_worker_group['정규직']) : `${this.won_comma(_worker_group['정규직'])} 명`,
                            styles: _total_worker_legend_value_styles
                        }
                    ],
                    [
                        {'content': `${this.$t('계약직', this.report_lang)}:`, styles: _total_worker_legend_title_styles},
                        {
                            'content': this.report_lang !== 'ko' ? this.won_comma(_worker_group['계약직']) : `${this.won_comma(_worker_group['계약직'])} 명`,
                            styles: _total_worker_legend_value_styles
                        }
                    ],
                    [
                        {'content': `${this.$t('일용직', this.report_lang)}:`, styles: _total_worker_legend_title_styles},
                        {
                            'content': this.report_lang !== 'ko' ? this.won_comma(_worker_group['일용직 근로자']) : `${this.won_comma(_worker_group['일용직 근로자'])} 명`,
                            styles: _total_worker_legend_value_styles
                        }
                    ],
                    [
                        {'content': `${this.$t('사내도급', this.report_lang)}:`, styles: _total_worker_legend_title_styles},
                        {
                            'content': this.report_lang !== 'ko' ? this.won_comma(_worker_group['사내도급 근로자']) : `${this.won_comma(_worker_group['사내도급 근로자'])} 명`,
                            styles: _total_worker_legend_value_styles
                        }
                    ]
                ]
            });

            position_y += _worker_box + this.jsPDFOpt.spacing.section_xs;

            position_y = this.addTitle(doc, position_y, 2, this.$t('평가결과', this.report_lang));


            // ESG 평가 총점
            position_y = this.addTitle(doc, position_y, 3, this.$t('ESG 평가 총점', this.report_lang), {
                skip_divider: true,
                no_padding: true
            });
            if (this.report_lang === 'en') {
                // doc.setFontSize(13.5)
                doc.setFontSize(12);
            } else {
                // doc.setFontSize(15)
                doc.setFontSize(13);
            }

            const _total_score_guide_box_padding = 10;
            const _total_score_guide_box_width = this.pageContentWidth;
            const _total_score_guide_area_width = _total_score_guide_box_width - (_total_score_guide_box_padding * 2);
            let _total_score_guide_text = doc.splitTextToSize(this.evaluation_score_description[this.report_lang], _total_score_guide_area_width);

            const _total_score_guide_dim = doc.getTextDimensions(_total_score_guide_text);
            const _total_score_guide_box_height = _total_score_guide_dim.h + (_total_score_guide_box_padding * 2);
            doc.setFillColor(...this.jsPDFOpt.card.fillColor);
            doc.setDrawColor(this.jsPDFOpt.card.borderColor);
            doc.rect(this.jsPDFOpt.margin.left, position_y, _total_score_guide_box_width, _total_score_guide_box_height, 'F');

            const _total_score_guide_text_position_x = this.jsPDFOpt.margin.left + _total_score_guide_box_padding;
            const _total_score_guide_text_position_y = position_y + ((_total_score_guide_box_height - _total_score_guide_dim.h) / 2) + (_total_score_guide_box_padding / 2);
            doc.text(_total_score_guide_text, _total_score_guide_text_position_x, _total_score_guide_text_position_y, {baseline: 'middle'});


            position_y += _total_score_guide_box_height + this.jsPDFOpt.spacing.title_xs;


            if (this.report_lang === 'en') {
                doc.setFontSize(12);
            } else {
                doc.setFontSize(13);
            }


            // 스코어박스 섹션
            const scorebox_height = this.report_lang === 'ko' ? 70 : 55;
            doc.setLineWidth(0);
            doc.setDrawColor(this.jsPDFOpt.card.borderColor);
            doc.setFillColor(...this.jsPDFOpt.card.fillColor);
            doc.rect(this.jsPDFOpt.margin.left, position_y, this.pageContentWidth, scorebox_height, 'D');
            position_y += scorebox_height;

            // 스코어박스 - 스코어 라벨(Total Score)
            if (this.report_lang === 'ca') {
                doc.setFont(this.jsPDFOpt.fontFamily_ca, 'normal');
            } else {
                doc.setFont(this.jsPDFOpt.fontFamily, 'normal');
            }

            doc.setFontSize(9.3);
            const _score_title_position_x = this.jsPDFOpt.margin.left + 10;
            const _score_title_position_y = (position_y - scorebox_height + 0.75) + this.jsPDFOpt.margin.top * 0.9;
            doc.text(this.report_lang === 'ca' ? '总分' : 'Total Score', _score_title_position_x, _score_title_position_y);


            // 스코어박스 - 스코어(점수)
            const total_score_width = this.pageContentWidth * 0.4;
            this.setFont(doc, 'cover_company_name');
            doc.setFontSize(30);

            const _score = this.scoringInfo.total['환산_점수'];
            const _score_text = this.report_lang !== 'ko' ? _score.toString() : `${_score} 점`;
            const _score_score = doc.splitTextToSize(_score_text, total_score_width);
            const _score_score_dim = doc.getTextDimensions(_score_score);
            const _score_position_x = _score_title_position_x + (((total_score_width - _score_title_position_x) - _score_score_dim.w) / 2);
            doc.text(_score_score, _score_position_x, position_y - (scorebox_height / 2) + (_score_score_dim.h / 2), {halign: 'center'});


            // 스코어박스 - 스코어바
            const scorebar_width = this.pageContentWidth * 0.6;
            const scorebar_height = 12;
            const scorebar_radius = 6;
            const scorebar_position_x = this.pageContentWidth * 0.425;
            const scorebar_position_y = position_y - (scorebox_height / 2) - (scorebar_height / 2);

            doc.setLineWidth(0);
            doc.setFillColor(228, 220, 211);
            doc.setDrawColor('#d6cdc4');
            doc.roundedRect(scorebar_position_x, scorebar_position_y, scorebar_width, scorebar_height, scorebar_radius, scorebar_radius, 'FD');

            // Draw the marker triangle
            const markerX = scorebar_position_x + ((_score / 100) * scorebar_width);
            doc.setFillColor(0, 0, 0);
            doc.triangle(markerX - 3, scorebar_position_y - 8, markerX + 3, scorebar_position_y - 8, markerX, scorebar_position_y - 3, 'F');

            // Draw the progress bar
            doc.setFillColor(84, 110, 122);
            doc.roundedRect(scorebar_position_x, scorebar_position_y, (_score / 100) * scorebar_width, scorebar_height, 5, 5, 'F');

            // Draw the Step Number
            doc.setFontSize(10);
            doc.setTextColor('#455A64');
            doc.text('0', scorebar_position_x, scorebar_position_y - 7);
            const _score_100_width = doc.getStringUnitWidth('100') * doc.getFontSize();
            doc.text('100', scorebar_position_x + scorebar_width - _score_100_width / 2, scorebar_position_y - 7);

            doc.setFontSize(9);
            doc.setTextColor('#999999');
            for (let i = 10; i < 100; i += 10) {
                doc.text(`${i}`, scorebar_position_x + (i / 100) * scorebar_width, scorebar_position_y + scorebar_height + 11, null, null, 'center');
            }
            position_y += this.jsPDFOpt.spacing.section_xs;

            // ESG 평가 영역별 결과
            position_y = this.addTitle(doc, position_y, 3, this.$t('ESG 평가 영역별 결과', this.report_lang), {footnote: this.$t('(각 영역별 점수는 100점 만점 기준 환산 값)', this.report_lang)});

            // ESG 평가 영역별 테이블
            let _category1_score_table_name_head = this.scoringInfo.category1.reduce((_added_category1_name, _category1) => {
                _added_category1_name.push({
                    content: _category1.question_name,
                    styles: {...this.tableStyles.th, fontSize: 10}
                });
                return _added_category1_name;
            }, []);

            let _category1_score_table_rows = [
                [
                    {
                        content: this.$t('영역별 점수', this.report_lang),
                        colSpan: 4,
                        styles: {...this.tableStyles.th, fontSize: 12},
                        minCellHeight: 25
                    }
                ],
                [..._category1_score_table_name_head]
            ];

            const _total_score_cell_width = 0;
            const _category1_score_cell_width = (this.pageContentWidth - _total_score_cell_width) / 4;
            const _category1_score_cell_height = this.pageContentHeight - position_y - this.jsPDFOpt.footerHeight;
            const _category1_score_chart_height = _category1_score_cell_height * 0.75;
            const _category1_score_chart_width = _category1_score_chart_height;
            let _category1_score_font_size = Math.min(19, 12 * (_category1_score_chart_height / 53));
            _category1_score_font_size = Math.max(13, _category1_score_font_size);

            let _category1_score_index = 0;
            let _category1_score_table_body = [];
            for (const _category1 of this.scoringInfo.category1) {
                if (this.category1PieChartInstance) {
                    this.category1PieChartInstance.destroy();
                    this.category1PieChartInstance = null;
                }

                _category1_score_table_body.push({
                    content: this.roundToOneDecimalPlace(_category1['환산_점수']),
                    category1_cell: true,
                    category1_score: this.roundToOneDecimalPlace(_category1['환산_점수']),
                    category1_img_url: await this.generateCategory1PieChartInstance(`rgba(${this.category1_composition_colors[_category1_score_index].join(',')})`, [this.roundToOneDecimalPlace(_category1['환산_점수']), 100 - this.roundToOneDecimalPlace(_category1['환산_점수'])]),
                    category1_question_name: _category1.question_name,
                    styles: {
                        ...this.tableStyles.td,
                        minCellHeight: _category1_score_cell_height,
                        cellWidth: _category1_score_cell_width,
                        valign: 'middle',
                        cellPadding: {top: 3.5},
                        fontSize: _category1_score_font_size
                    }
                });
                ++_category1_score_index;
            }

            _category1_score_table_rows.push(_category1_score_table_body);


            autoTable(doc, {
                theme: 'grid',
                startY: position_y,
                margin: {...this.jsPDFOpt.margin, top: 0, left: this.jsPDFOpt.margin.left},
                styles: {...this.tableStyles.global, halign: 'center'},
                body: _category1_score_table_rows,
                didDrawCell: async (data) => {
                    if (data.cell.raw?.category1_cell && data.cell.raw?.category1_cell === true) {
                        const _category1_score_chart_positon_x = data.cell.x + ((_category1_score_cell_width - _category1_score_chart_width) / 2);
                        const _category1_score_chart_positon_y = data.cell.y + ((_category1_score_cell_height - _category1_score_chart_height) / 2); // + 0.5

                        doc.addImage(data.cell.raw.category1_img_url, 'png', _category1_score_chart_positon_x, _category1_score_chart_positon_y, _category1_score_chart_width, _category1_score_chart_height);
                        if (this.category1PieChartInstance) {
                            this.category1PieChartInstance.destroy();
                            this.category1PieChartInstance = null;
                        }
                    }
                }
            });

            position_y = doc.lastAutoTable.finalY + this.jsPDFOpt.spacing.section_md;
            return position_y;
        },
        async generateRiskandCompliancePage(doc, position_y) {
            position_y = this.firstElementSpacing;
            doc.addPage();
            this.addHeader(doc);

            // "지표구성" 섹션 타이틀
            position_y = this.addTitle(doc, position_y, 1, this.$t('지표 구성', this.report_lang));

            // 지표구성 & IMPORTANCE 백분률 차트 섹션
            const _section_subs_risk_composition_chartBox_padding = 5;
            const _section_subs_risk_composition_half = (this.pageContentWidth / 2) + this.jsPDFOpt.margin.left + _section_subs_risk_composition_chartBox_padding;

            // 지표구성, IMPORTANCE - 제목 추가
            this.addTitle(doc, position_y, 3, this.$t('지표 구성', this.report_lang), {
                skip_divider: true,
                no_padding: true
            });
            position_y = this.addTitle(doc, position_y, 3, this.$t('중요도 구성', this.report_lang), {
                skip_divider: true,
                no_padding: true,
                position_x: _section_subs_risk_composition_half
            });

            const _section_subs_risk_composition_chartBox_width = (this.pageContentWidth / 2) - _section_subs_risk_composition_chartBox_padding;
            const _section_subs_risk_composition_chartBox_heigth = 93;
            const _section_subs_risk_composition_chartArea = _section_subs_risk_composition_chartBox_heigth - (_section_subs_risk_composition_chartBox_padding * 2);
            const _section_subs_risk_composition_chartArea_position_y = position_y + ((_section_subs_risk_composition_chartBox_heigth - _section_subs_risk_composition_chartArea) / 2);

            // 지표구성 - 차트 추가
            doc.setFillColor(...this.jsPDFOpt.card.fillColor);
            doc.rect(this.jsPDFOpt.margin.left, position_y, _section_subs_risk_composition_chartBox_width, _section_subs_risk_composition_chartBox_heigth, 'F');
            const _subs_composition_pieChart_url = await this.generateSubsCompositionPieChartInstance();
            const _subs_composition_pieChart_position_x_start = this.report_lang === 'en'
                ? this.jsPDFOpt.margin.left + (_section_subs_risk_composition_chartBox_padding)
                : this.jsPDFOpt.margin.left + (_section_subs_risk_composition_chartBox_padding * 2);
            const _subs_composition_pieChart_position_x_end = _subs_composition_pieChart_position_x_start + _section_subs_risk_composition_chartArea;
            doc.addImage(_subs_composition_pieChart_url, 'png', _subs_composition_pieChart_position_x_start, _section_subs_risk_composition_chartArea_position_y, _section_subs_risk_composition_chartArea, _section_subs_risk_composition_chartArea);

            let _cat1_subs_legend_width = _section_subs_risk_composition_chartBox_width - _section_subs_risk_composition_chartArea;
            let _cat1_subs_legend_position_y = this.report_lang === 'en'
                ? _section_subs_risk_composition_chartArea_position_y + (_section_subs_risk_composition_chartBox_padding * 0.75) + 3
                : _section_subs_risk_composition_chartArea_position_y + (_section_subs_risk_composition_chartBox_padding * 0.75) + 7;
            let _cat1_subs_legend_indicator_position_x = _subs_composition_pieChart_position_x_end + (_section_subs_risk_composition_chartBox_padding * 2);
            let _cat1_subs_legend_fontSize = 8.5;
            let _cat1_subs_legend_label_position_x = _cat1_subs_legend_indicator_position_x + _cat1_subs_legend_fontSize + 5.5;
            let _cat1_subs_legend_label_max_width = this.category1_composition.reduce((_label_max_width, {
                category1_question_name,
                category1_question_name_ca,
                category1_question_name_ea
            }) => {
                let _label = this.report_lang === 'ko'
                    ? category1_question_name
                    : this.report_lang === 'en'
                        ? category1_question_name_ea
                        : category1_question_name_ca;


                _label = doc.splitTextToSize(_label, _cat1_subs_legend_width * 0.6);
                const _label_dim = doc.getTextDimensions(_label, {fontSize: _cat1_subs_legend_fontSize});

                _label_max_width = _label_max_width > _label_dim.w ? _label_max_width : _label_dim.w;
                return _label_max_width;
            }, 0) + 6.5;

            // 지표구성 - legend
            this.category1_composition.forEach((_cat1_subs, _cat1_subs_idx) => {
                // 지표구성 - legend - indicator
                doc.setLineWidth(0.2);
                doc.setDrawColor(this.jsPDFOpt.card.borderColor);
                doc.setFillColor(...this.category1_composition_colors[_cat1_subs_idx].slice(0, 3));
                doc.rect(_cat1_subs_legend_indicator_position_x, _cat1_subs_legend_position_y, _cat1_subs_legend_fontSize, _cat1_subs_legend_fontSize, 'FD');

                // 지표구성 - legend - label
                const {
                    category1_question_name,
                    category1_question_name_ca,
                    category1_question_name_ea,
                    count
                } = _cat1_subs;
                let _cat_name = this.report_lang === 'ko'
                    ? category1_question_name
                    : this.report_lang === 'en' ? category1_question_name_ea : category1_question_name_ca;
                doc.setFontSize(_cat1_subs_legend_fontSize);
                _cat_name = doc.splitTextToSize(_cat_name, _cat1_subs_legend_label_max_width);
                const _cat_name_dim = doc.getTextDimensions(_cat_name, {fontSize: _cat1_subs_legend_fontSize});
                doc.text(_cat_name, _cat1_subs_legend_label_position_x, _cat1_subs_legend_position_y + (_cat_name_dim.h / _cat_name.length));

                // 지표구성 - legend - datalabel
                const _cat1_datalabel = doc.splitTextToSize(this.report_lang === 'ko' ? `${count} 개` : count);
                const _cat1_datalabel_dim = doc.getTextDimensions(_cat1_datalabel, {fontSize: _cat1_subs_legend_fontSize});
                doc.text(_cat1_datalabel, _cat1_subs_legend_label_position_x + _cat1_subs_legend_label_max_width, _cat1_subs_legend_position_y + _cat1_datalabel_dim.h);

                // 지표구성 - legend - 누적 position_y
                _cat1_subs_legend_position_y += _cat_name_dim.h + _cat1_subs_legend_fontSize + (_section_subs_risk_composition_chartBox_padding * 0.75);
            });

            // IMPORTANCE - 차트 추가
            doc.setFillColor(...this.jsPDFOpt.card.fillColor);
            doc.rect(_section_subs_risk_composition_half, position_y, _section_subs_risk_composition_chartBox_width, _section_subs_risk_composition_chartBox_heigth, 'F');
            const _importance_composition_pieChart_url = await this.generateImportanceCompositionPieChartInstance();
            const _importance_composition_pieChart_position_x_start = _section_subs_risk_composition_half + (_section_subs_risk_composition_chartBox_padding * 2);
            const _importance_composition_pieChart_position_x_end = _importance_composition_pieChart_position_x_start + _section_subs_risk_composition_chartArea;
            doc.addImage(_importance_composition_pieChart_url, 'png', _importance_composition_pieChart_position_x_start, _section_subs_risk_composition_chartArea_position_y, _section_subs_risk_composition_chartArea, _section_subs_risk_composition_chartArea);

            let _importance_composition_legend_position_y = _section_subs_risk_composition_chartArea_position_y + (_section_subs_risk_composition_chartBox_padding * 0.75) + 15;
            let _importance_composition_legend_indicator_position_x = _importance_composition_pieChart_position_x_end + 13;

            let _importance_composition_legend_label_position_x = _importance_composition_legend_indicator_position_x + _cat1_subs_legend_fontSize + 5.5;
            let _importance_composition_legend_label_max_width = Object.keys(this.importance_composition).reduce((_label_max_width, label) => {
                const _importance_label = doc.splitTextToSize(label);
                const _importance_label_dim = doc.getTextDimensions(_importance_label, {fontSize: _cat1_subs_legend_fontSize});
                _label_max_width = _label_max_width > _importance_label_dim.w ? _label_max_width : _importance_label_dim.w;
                return _label_max_width;
            }, 0) + 6.5;

            // 중요도 구성 - legend
            Object.entries(this.importance_composition).forEach(([_impotance, _val], _importance_idx) => {
                // 중요도 구성 - legend - indicator
                doc.setLineWidth(0.2);
                doc.setDrawColor(this.jsPDFOpt.card.borderColor);
                // doc.setFillColor(...this.jsPDFOpt.card.fillColor)
                doc.setFillColor(...this.importance_composition_colors[_importance_idx].slice(0, 3));
                doc.rect(_importance_composition_legend_indicator_position_x, _importance_composition_legend_position_y, _cat1_subs_legend_fontSize, _cat1_subs_legend_fontSize, 'FD');

                // 중요도 구성 - legend - label
                doc.setFontSize(_cat1_subs_legend_fontSize);
                const _importance_label = doc.splitTextToSize(_impotance);
                const _importance_dim = doc.getTextDimensions(_importance_label, {fontSize: _cat1_subs_legend_fontSize});
                doc.text(_importance_label, _importance_composition_legend_label_position_x, _importance_composition_legend_position_y + _importance_dim.h);

                // 중요도 구성 - legend - datalabel
                const _importance_datalabel = doc.splitTextToSize(this.report_lang === 'ko' ? `${_val} 개` : _val);
                doc.text(_importance_datalabel, _importance_composition_legend_label_position_x + _importance_composition_legend_label_max_width, _importance_composition_legend_position_y + _importance_dim.h);

                // 중요도 구성 - legend - 누적 position_y
                _importance_composition_legend_position_y += _importance_dim.h + _cat1_subs_legend_fontSize + (_section_subs_risk_composition_chartBox_padding * 0.75);
            });

            position_y += _section_subs_risk_composition_chartBox_heigth + this.jsPDFOpt.spacing.section_xs;

            // 지표 구성 및 중요도 구성 진단
            const _subs_composition_box_position_x = this.jsPDFOpt.margin.left;
            const _subs_composition_padding = _section_subs_risk_composition_chartBox_padding * 3;
            const _subs_composition_area_width = this.pageContentWidth - _subs_composition_padding;

            this.setFont(doc, 'table_td', null, 'normal');
            doc.setFontSize(11);
            doc.setLineHeightFactor(1.55);

            const _sub_composition_description = doc.splitTextToSize(this.sub_imporatance_composition_description, _subs_composition_area_width);
            const _sub_composition_text_dim = doc.getTextDimensions(_sub_composition_description, {fontSize: 12});

            doc.setLineWidth(0.5);
            doc.setFillColor(...this.jsPDFOpt.card.fillColor);
            doc.setDrawColor(224, 224, 224);
            const _subs_composition_box_height = _sub_composition_text_dim.h + _subs_composition_padding;
            const _subs_composition_box_width = this.pageContentWidth;
            doc.rect(this.jsPDFOpt.margin.left, position_y, _subs_composition_box_width, _subs_composition_box_height, 'FD');

            position_y += 11 - 1.55;
            const _subs_composition_area_position_x = _subs_composition_box_position_x + ((_subs_composition_box_width - _sub_composition_text_dim.w) / 2) + _subs_composition_padding;
            const _subs_composition_area_position_y = position_y + ((_subs_composition_box_height - _sub_composition_text_dim.h) / 2);
            doc.text(_sub_composition_description, _subs_composition_area_position_x, _subs_composition_area_position_y);
            doc.setLineHeightFactor(1.15);

            position_y += _sub_composition_text_dim.h + this.jsPDFOpt.spacing.section_sm;


            // 지표구성 & 리스크 노출수준 ~ 컴플라이언스 이슈 섹션 divider
            doc.setLineWidth(0.5);
            doc.setDrawColor('#E0E0E0');
            doc.line(this.jsPDFOpt.margin.left, position_y, this.jsPDFOpt.margin.left + this.pageContentWidth, position_y);

            position_y += this.jsPDFOpt.spacing.section_xs;

            // 잠재적 리스크 노출
            position_y = this.addTitle(doc, position_y, 2, this.$t('잠재적 리스크 노출', this.report_lang), {skip_divider: false});

            this.setFont(doc, 'table_td', null, 'normal');
            doc.setFontSize(9);
            doc.setLineHeightFactor(1.55);

            const _risk_description_box_width = this.pageContentWidth;
            const _risk_description_area_width = this.pageContentWidth - _subs_composition_padding;

            const _risk_description = doc.splitTextToSize(this.risk_description, _risk_description_area_width);
            const _risk_description_dim = doc.getTextDimensions(_risk_description);

            doc.setLineWidth(0.5);
            doc.setFillColor(...this.jsPDFOpt.card.fillColor);
            doc.setDrawColor(224, 224, 224);

            const _risk_description_box_height = _risk_description_dim.h + _subs_composition_padding;
            const _risk_description_box_position_x = this.jsPDFOpt.margin.left;
            doc.rect(this.jsPDFOpt.margin.left, position_y, _risk_description_box_width, _risk_description_box_height, 'FD');

            const _risk_description_area_position_x = _risk_description_box_position_x + ((_risk_description_box_width - _risk_description_dim.w) / 2);
            const _risk_description_area_position_y = position_y + ((_risk_description_box_height - _risk_description_dim.h) / 2) + 7;

            doc.text(_risk_description, _risk_description_area_position_x, _risk_description_area_position_y);
            position_y += _risk_description_box_height + this.jsPDFOpt.spacing.section_xs;


            const _risk_compliacne_table_width = this.pageContentWidth;
            const _risk_compliance_common_table_column_width = {
                question: _risk_compliacne_table_width * 0.2,
                details: _risk_compliacne_table_width * 0.8
            };

            this.category1_composition.forEach(_category1 => {
                if (this.checkNeedNewPage(doc, position_y, 60)) {
                    position_y = this.firstElementSpacing;
                }

                const {category1_question_name, category1_question_name_ca, category1_question_name_ea} = _category1;
                const _category1_name = this.showTranslation(category1_question_name, category1_question_name_ea, category1_question_name_ca, this.report_lang);
                position_y = this.addTitle(doc, position_y, 3, _category1_name, {
                    skip_divider: true,
                    no_padding: true,
                    no_margin: true
                });
                if (this.checkNeedNewPage(doc, position_y, 30)) {
                    position_y = this.firstElementSpacing;
                }

                const _category1_risk_composition = this.risk_composition.find(risk => risk.category1_question_name === category1_question_name);
                const _category1_risk_rows = _category1_risk_composition && _category1_risk_composition.item.length
                    ? _category1_risk_composition.item.reduce((_cat1_risk_table_rows, _cat1_risk) => {
                        if (_cat1_risk.ev_name) {
                            _cat1_risk_table_rows.push([
                                {content: _cat1_risk.sub_code},
                                {content: this.showTranslation(_cat1_risk.ev_name, _cat1_risk.ev_name_e, _cat1_risk.ev_name_c, this.report_lang)}
                            ]);
                        }

                        return _cat1_risk_table_rows;
                    }, [])
                    : [[{content: this.$t('리스크 사항 없음', this.report_lang), colSpan: 3}]];

                autoTable(doc, {
                    theme: 'grid',
                    startY: position_y,
                    tableWidth: _risk_compliacne_table_width,
                    useCss: true,
                    rowPageBreak: 'avoid',
                    margin: {...this.jsPDFOpt.margin, top: this.firstElementSpacing},
                    styles: {...this.tableStyles.global, halign: 'center'},
                    headStyles: {
                        ...this.tableStyles.th,
                        fontSize: 9,
                        minCellHeight: 12,
                        cellPadding: {top: 5, bottom: 2}
                    },
                    bodyStyles: {...this.tableStyles.td, fontSize: 8.5, minCellHeight: 10},
                    columnStyles: {
                        0: {
                            cellPadding: {top: 6, bottom: 2},
                            cellWidth: _risk_compliance_common_table_column_width['question'],
                            valign: 'middle'
                        },
                        1: {
                            cellPadding: {top: 6, right: 6, bottom: 2, left: 6},
                            cellWidth: _risk_compliance_common_table_column_width['details'],
                            halign: 'left', valign: 'middle'
                        }
                    },
                    head: [[
                        {content: this.$t('문항', this.report_lang),},
                        {content: this.$t('리스크 내용', this.report_lang)},
                    ]],
                    body: _category1_risk_rows,
                    didDrawPage: (HookData) => {
                        this.addHeader(HookData.doc);
                    }
                });

                position_y = doc.lastAutoTable.finalY + this.jsPDFOpt.spacing.section_xs;
            });

            position_y += this.jsPDFOpt.spacing.section_sm - 15;

            if (this.checkNeedNewPage(doc, position_y, 70)) {
                position_y = this.firstElementSpacing;
            }

            // 컴플라이언스 이슈
            position_y = this.addTitle(doc, position_y, 2, this.$t('컴플라이언스 이슈', this.report_lang), {skip_divider: false});

            this.setFont(doc, 'table_td', null, 'normal');
            doc.setFontSize(9);
            doc.setLineHeightFactor(1.55);

            const _compliance_description_box_width = this.pageContentWidth;
            const _compliance_description_area_width = this.pageContentWidth - _subs_composition_padding;

            const _compliance_description = doc.splitTextToSize(this.compliance_description, _compliance_description_area_width);
            const _compliance_description_dim = doc.getTextDimensions(_compliance_description);


            doc.setLineWidth(0.5);
            doc.setFillColor(...this.jsPDFOpt.card.fillColor);
            doc.setDrawColor(224, 224, 224);
            const _compliance_description_box_height = _compliance_description_dim.h + _subs_composition_padding;

            const _compliance_description_box_position_x = this.jsPDFOpt.margin.left;
            doc.rect(this.jsPDFOpt.margin.left, position_y, _compliance_description_box_width, _compliance_description_box_height + (this.report_lang === 'ko' ? 12 : 25), 'FD');

            const _compliance_description_area_position_x = _compliance_description_box_position_x + ((_compliance_description_box_width - _compliance_description_dim.w) / 3);
            const _compliance_description_area_position_y = position_y + ((_compliance_description_box_height - _compliance_description_dim.h) / 2) + 7;

            doc.text(_compliance_description, _compliance_description_area_position_x, _compliance_description_area_position_y);
            position_y += _compliance_description_box_height + this.jsPDFOpt.spacing.section_xs + (this.report_lang === 'ko' ? 12 : 25);

            this.category1_composition.forEach(_category1 => {
                if (this.checkNeedNewPage(doc, position_y, 30)) {
                    position_y = this.firstElementSpacing;
                }

                const {category1_question_name, category1_question_name_ca, category1_question_name_ea} = _category1;
                const _category1_name = this.showTranslation(category1_question_name, category1_question_name_ea, category1_question_name_ca, this.report_lang);
                position_y = this.addTitle(doc, position_y, 3, _category1_name, {
                    skip_divider: true,
                    no_padding: true,
                    no_margin: true
                });
                if (this.checkNeedNewPage(doc, position_y, 30)) {
                    position_y = this.firstElementSpacing;
                }

                const _category1_compliance_composition = this.compliance_composition.find(compliance => compliance.category1_question_name === category1_question_name);
                const _category1_compliance_rows = _category1_compliance_composition && _category1_compliance_composition.item.length
                    ? _category1_compliance_composition.item.reduce((_cat1_risk_table_rows, _cat1_risk) => {
                        let ev_details = this.showTranslation(_cat1_risk.ev_reverse_name, _cat1_risk.ev_reverse_name_e, _cat1_risk.ev_reverse_name_c, this.report_lang);
                        if (ev_details) {
                            _cat1_risk_table_rows.push([
                                {content: _cat1_risk.sub_code},
                                {content: ev_details.trim()}
                            ]);
                        }
                        return _cat1_risk_table_rows;
                    }, [])
                    : [[{content: this.$t('컴플라이언스 이슈 없음', this.report_lang), colSpan: 2}]];

                autoTable(doc, {
                    theme: 'grid',
                    startY: position_y,
                    tableWidth: _risk_compliacne_table_width,
                    useCss: true,
                    rowPageBreak: 'avoid',
                    margin: {...this.jsPDFOpt.margin, top: this.firstElementSpacing},
                    styles: {...this.tableStyles.global, halign: 'center'},
                    headStyles: {
                        ...this.tableStyles.th,
                        fontSize: 9,
                        minCellHeight: 12,
                        cellPadding: {top: 5, bottom: 2}
                    },
                    bodyStyles: {...this.tableStyles.td, fontSize: 8.5, minCellHeight: 10},
                    columnStyles: {
                        0: {
                            cellPadding: {top: 6, bottom: 2},
                            cellWidth: _risk_compliance_common_table_column_width['question'],
                            valign: 'middle'
                        },
                        1: {
                            cellPadding: {top: 6, right: 6, bottom: 2, left: 6},
                            cellWidth: _risk_compliance_common_table_column_width['details'],
                            halign: 'left', valign: 'middle'
                        }
                    },
                    head: [[
                        {content: this.$t('문항', this.report_lang),},
                        {content: this.$t('리스크 내용', this.report_lang)},
                    ]],
                    body: _category1_compliance_rows,
                    didDrawPage: (HookData) => {
                        this.addHeader(HookData.doc);
                    }
                });

                position_y = doc.lastAutoTable.finalY + this.jsPDFOpt.spacing.section_xs;
            });

            return position_y;
        },
        generatecategory1AreaChartInstance(_data = this.scoringInfo.category1, opt = {}) {
            return new Promise((resolve) => {
                if (!_data) {
                    _data = this.scoringInfo.category1;
                }

                let _category1_data = _data.map(({환산_점수}) => 환산_점수);
                let _category1_label = _data.map(({question_name}) => this.$t(question_name, this.report_lang));
                if (this.report_lang === 'en') {
                    _category1_label = this.splitByManagement(_category1_label);
                }


                if (!opt.emphasis || typeof opt.emphasis === 'undefined') {
                    opt.emphasis = false;
                }

                let emphasis_max_label = null;
                if (!opt.emphasis_max || typeof opt.emphasis_max === 'undefined') {
                    opt.emphasis_max = false;
                } else {
                    let _max_score = Math.max(..._category1_data);
                    emphasis_max_label = _data.find(({환산_점수}) => 환산_점수 === _max_score);
                    emphasis_max_label = this.splitByManagement(this.$t(emphasis_max_label.question_name, this.report_lang));
                }

                let emphasis_min_label = null;
                if (!opt.emphasis_min || typeof opt.emphasis_min === 'undefined') {
                    opt.emphasis_min = false;
                } else {
                    let _min_score = Math.min(..._category1_data);
                    emphasis_min_label = _data.find(({환산_점수}) => 환산_점수 === _min_score);
                    emphasis_min_label = this.splitByManagement(this.$t(emphasis_min_label.question_name, this.report_lang));
                }

                const _scope1_data = {
                    labels: _category1_label,
                    datasets: [{
                        data: _category1_data,
                        fill: true,
                        backgroundColor: 'rgba(194, 24, 91, 0.4)',
                        borderColor: 'rgb(194, 24, 91)',
                        pointBorderColor: (context) => {
                            if (opt.emphasis_max) {
                                if (_category1_label[context.index] === emphasis_max_label) {
                                    return 'rgba(194, 24, 91, 1)';
                                }
                            }

                            if (opt.emphasis_min) {
                                if (_category1_label[context.index] === emphasis_min_label) {
                                    return 'rgba(229, 57, 53, 1)';
                                }
                            }

                            if (opt.emphasis) {
                                if (_category1_label[context.index] === opt.emphasis_label) {
                                    return 'rgba(194, 24, 91, 1)';
                                }
                            }

                            return 'rgb(206, 66, 122)';
                        },
                        pointBackgroundColor: (context) => {
                            if (opt.emphasis_max) {
                                if (_category1_label[context.index] === emphasis_max_label) {
                                    return 'rgba(194, 24, 91, 0.6)';
                                }
                            }

                            if (opt.emphasis_min) {
                                if (_category1_label[context.index] === emphasis_min_label) {
                                    return 'rgba(229, 57, 5, 0.6)';
                                }
                            }

                            if (opt.emphasis) {
                                if (_category1_label[context.index] === opt.emphasis_label) {
                                    return 'rgba(194, 24, 91, 0.6)';
                                }
                            }

                            return 'rgba(181, 69, 114, 0.5)';
                        }
                    }]
                };

                const _common_option = {
                    global: {
                        aspectRatio: this.report_lang === 'en' ? null : 4.7 / 3,
                        responsive: false,
                        maintainAspectRatio: false,
                        devicePixelRatio: 1.5,
                        responsiveAnimationDuration: 0,
                        animation: {
                            duration: 0,
                            onComplete: function () {
                                resolve(this.toBase64Image('image/jpg', 1));
                            }
                        }
                    },
                    plugins: {
                        legend: {display: false},
                        datalabels: {
                            display: false
                        },
                    },
                    scales: {
                        max: 100,
                        beginAtZero: true,
                        ticks: {
                            display: false
                        }
                    },
                    layout: {}
                };

                let _font_size = {
                    default: this.report_lang === 'en' ? 12.5 : 14.5,
                    enphasis: this.report_lang === 'en' ? 13.5 : this.report_lang === 'ca' ? 15.5 : 16
                };

                const _scope1_area_option = {
                    ..._common_option.global,
                    layout: _common_option.layout,
                    elements: {line: {borderWidth: 1.5}},
                    scales: {
                        r: {
                            ..._common_option.scales,
                            ticks: {
                                ..._common_option.scales.ticks,
                                stepSize: 25,
                                color: '#E0E0E0',
                                autoSkip: false, // 레이블 건너뛰기 해제
                                overflow: 'hidden' // 레이블이 차트 영역 밖으로 넘치지 않도록 설정
                            },
                            grid: {
                                color: '#E0E0E0'
                            },
                            pointLabels: {
                                display: true,
                                padding: 7,
                                font: {
                                    size: (context) => {
                                        if (opt.emphasis_max) {
                                            if (context.label === emphasis_max_label) {
                                                return _font_size.enphasis;
                                            }
                                        }

                                        if (opt.emphasis_min) {
                                            if (context.label === emphasis_min_label) {
                                                return _font_size.enphasis;
                                            }
                                        }

                                        if (opt.emphasis) {
                                            if (context.label === opt.emphasis_label) {
                                                return _font_size.enphasis;
                                            }
                                        }

                                        return _font_size.default;
                                    },
                                    weight: (context) => {
                                        if (opt.emphasis_max) {
                                            if (context.label === emphasis_max_label) {
                                                return 700;
                                            }
                                        }

                                        if (opt.emphasis_min) {
                                            if (context.label === emphasis_min_label) {
                                                return 700;
                                            }
                                        }

                                        if (opt.emphasis) {
                                            if (context.label === opt.emphasis_label) {
                                                return 700;
                                            }
                                        }

                                        return 500;
                                    },
                                },
                                color: (context) => {
                                    if (opt.emphasis_max) {
                                        if (context.label === emphasis_max_label) {
                                            return 'rgba(194, 24, 91, 1)';
                                        }
                                    }

                                    if (opt.emphasis_min) {
                                        if (context.label === emphasis_min_label) {
                                            return 'rgba(229, 57, 5, 1)';
                                        }
                                    }

                                    if (opt.emphasis) {
                                        if (context.label === opt.emphasis_label) {
                                            return 'rgba(194, 24, 91, 1)';
                                        }
                                    }

                                    return '#616161';
                                }
                            }
                        }
                    },
                    plugins: _common_option.plugins
                };

                if (!this.category1AreaChartInstance) {
                    this.category1AreaChartInstance = this.$chartjs.createChart(
                        document.getElementById('category1-chart-area'),
                        {
                            type: 'radar',
                            data: _scope1_data,
                            options: _scope1_area_option
                        }
                    );
                } else {
                    this.$chartjs.updateChart(this.category1AreaChartInstance, _scope1_data, _scope1_area_option);
                }

            });
        },
        generateCategory1ContraryAreaChartInstance(_data = this.scoringInfo.category1) {
            return new Promise((resolve) => {
                if (!_data) {
                    _data = this.scoringInfo.category1;
                }

                const _scope1_data = {
                    labels: this.scoringInfo.category1.map(({question_name}) => question_name),
                    datasets: [
                        {
                            label: this.headerInfo.company_name,
                            data: this.scoringInfo.category1.map(({환산_점수}) => 환산_점수),
                            borderColor: 'rgba(194, 24, 91, 0.6)',
                            backgroundColor: 'rgba(194, 24, 91, 0.1)',
                            pointBackgroundColor: 'rgba(194, 24, 91, 1)',
                            pointBorderColor: 'rgba(194, 24, 91, 0.6)',
                            pointRadius: 4,
                            borderWidth: 2,
                            tension: 0
                        },
                        {
                            label: this.benchMarkScoreLabel('avg'),
                            data: Object.values(this.benchMarkScore.category1).map(({avg}) => avg),
                            borderColor: '#888',
                            backgroundColor: 'transparent',
                            borderDash: [4, 4],
                            pointBackgroundColor: '#888',
                            pointBorderColor: '#888',
                            pointRadius: 3,
                            borderWidth: 1,
                            tension: 0
                        },
                        {
                            label: this.benchMarkScoreLabel('top'),
                            data: Object.values(this.benchMarkScore.category1).map(({top}) => top),
                            borderColor: '#c4a986',
                            backgroundColor: 'transparent',
                            borderDash: [2, 4],
                            pointBackgroundColor: '#c4a986',
                            pointBorderColor: '#c4a986',
                            pointRadius: 3,
                            borderWidth: 1,
                            tension: 0
                        }
                    ]
                };


                const _common_option = {
                    global: {
                        // aspectRatio: this.report_lang === 'en' ? null : 4.7/3,
                        responsive: false,
                        maintainAspectRatio: false,
                        devicePixelRatio: 1.5,
                        responsiveAnimationDuration: 0,
                        animation: {
                            duration: 0,
                            onComplete: function () {
                                resolve(this.toBase64Image('image/jpg', 1));
                            }
                        }
                    }
                };

                const _scope1_area_option = {
                    ..._common_option.global,
                    layout: {
                        padding: 0
                    },
                    plugins: {
                        legend: {
                            position: 'top',
                            align: 'start',
                            labels: {
                                boxWidth: 13,
                                padding: 10,
                                font: {
                                    size: 13
                                }
                            }
                        },
                        datalabels: {display: false}
                    },
                    scales: {
                        r: {
                            min: 0,
                            max: 100,
                            ticks: {
                                display: false,
                            },
                            grid: false,
                            pointLabels: {
                                padding: 8,
                                font: {
                                    size: this.report_lang === 'en' ? 15 : 15,
                                    weight: 'bold'
                                }
                            }
                        }
                    }
                };

                if (!this.category1ContraryAreaChartInstance) {
                    this.category1ContraryAreaChartInstance = this.$chartjs.createChart(
                        document.getElementById('category1-contrary-chart-area'),
                        {
                            type: 'radar',
                            data: _scope1_data,
                            options: _scope1_area_option
                        }
                    );
                } else {
                    this.$chartjs.updateChart(this.category1ContraryAreaChartInstance, _scope1_data, _scope1_area_option);
                }
            });
        },
        generateSubsCompositionPieChartInstance() {
            return new Promise((resolve) => {
                const _scope1_data = {
                    datasets: [{
                        data: this.category1_composition.map(({count}) => count),
                        fill: true,
                        backgroundColor: this.category1_composition_colors.map(_color => `rgba(${_color.join(',')})`),
                        borderColor: [
                            'rgba(256, 256, 256, 1)',
                            'rgba(256, 256, 256, 1)',
                            'rgba(256, 256, 256, 1)',
                            'rgba(256, 256, 256, 1)'
                        ],
                        borderWidth: 4
                    }]
                };

                const _common_option = {
                    global: {
                        aspectRatio: 5 / 5,
                        responsive: false,
                        maintainAspectRatio: false,
                        responsiveAnimationDuration: 0,
                        animation: {
                            duration: 0,
                            onComplete: function () {
                                resolve(this.toBase64Image('image/jpg', 1));
                            }
                        }
                    },
                    plugins: {
                        datalabels: {display: true}
                    },
                };

                const _scope1_area_option = {
                    ..._common_option.global,
                    elements: {line: {borderWidth: 1}},
                    scales: {},
                    plugins: {
                        datalabels: {
                            formatter: (value, ctx) => {
                                const total = ctx.chart.data.datasets[0].data.reduce((a, b) => a + b, 0);
                                const share = ((value / total) * 100).toFixed(1);
                                return `${share} %`;
                            },
                            display: ({dataset, dataIndex}) => {
                                const {data} = dataset;
                                const total = data.reduce((a, b) => a + b, 0);
                                const share = Number(((data[dataIndex] / total) * 100).toFixed(1));
                                return share >= 11;
                            },
                            font: {
                                family: 'Roboto',
                                size: 21.5,
                                weight: 'bold'
                            },
                            color: '#fff',
                            textAlign: 'center',
                            clamp: false
                        }
                    }
                };

                if (!this.subsCompositionPieChartInstance) {
                    this.subsCompositionPieChartInstance = this.$chartjs.createChart(
                        document.getElementById('subs-composition-chart-pie'),
                        {
                            type: 'pie',
                            data: _scope1_data,
                            options: _scope1_area_option
                        }
                    );
                } else {
                    this.$chartjs.updateChart(this.subsCompositionPieChartInstance, _scope1_data, _scope1_area_option);
                }
            });
        },
        generateImportanceCompositionPieChartInstance() {
            return new Promise((resolve) => {
                const _scope1_data = {
                    datasets: [{
                        data: Object.values(this.importance_composition),
                        fill: true,
                        backgroundColor: this.importance_composition_colors.map(_color => `rgba(${_color.join(',')})`),
                        borderColor: [
                            'rgba(256, 256, 256, 1)',
                            'rgba(256, 256, 256, 1)',
                            'rgba(256, 256, 256, 1)',
                            'rgba(256, 256, 256, 1)'
                        ],
                        borderWidth: 4
                    }]
                };

                const _common_option = {
                    global: {
                        aspectRatio: 5 / 5,
                        responsive: false,
                        maintainAspectRatio: false,
                        responsiveAnimationDuration: 0,
                        animation: {
                            duration: 0,
                            onComplete: function () {
                                resolve(this.toBase64Image('image/jpg', 1));
                            }
                        }
                    },
                    plugins: {
                        datalabels: {display: true}
                    },
                };

                const _scope1_area_option = {
                    ..._common_option.global,
                    elements: {line: {borderWidth: 0}},
                    scales: {},
                    plugins: {
                        datalabels: {
                            formatter: (value, ctx) => {
                                const total = ctx.chart.data.datasets[0].data.reduce((a, b) => a + b, 0);
                                const share = ((value / total) * 100).toFixed(1);
                                return `${share} %`;
                            },
                            display: ({dataset, dataIndex}) => {
                                const {data} = dataset;
                                const total = data.reduce((a, b) => a + b, 0);
                                const share = Number(((data[dataIndex] / total) * 100).toFixed(1));
                                return share >= 11;
                            },
                            font: {
                                family: 'Roboto',
                                size: 21.5,
                                weight: 'bold'
                            },
                            color: '#fff',
                            textAlign: 'center',
                            clamp: false
                        }
                    }
                };

                if (!this.imporanceCompositionPieChartInstance) {
                    this.imporanceCompositionPieChartInstance = this.$chartjs.createChart(
                        document.getElementById('importance-composition-chart-pie'),
                        {
                            type: 'pie',
                            data: _scope1_data,
                            options: _scope1_area_option
                        }
                    );
                } else {
                    this.$chartjs.updateChart(this.imporanceCompositionPieChartInstance, _scope1_data, _scope1_area_option);
                }
            });
        },

        generateCategory1PieChartInstance(keyColor, category1_score) {
            return new Promise((resolve) => {
                const _scope1_data = {
                    datasets: [{
                        data: category1_score,
                        fill: true,
                        backgroundColor: [
                            // 'rgba(96, 125, 139, 1)',
                            keyColor,
                            'rgba(236, 239, 241, 0.7)'
                        ],
                        borderColor: [
                            // 'rgba(96, 125, 139, 1)',
                            keyColor,
                            'rgba(144, 164, 174, 0.6)'
                        ],
                    }]
                };

                const _common_option = {
                    global: {
                        aspectRatio: 5 / 5,
                        responsive: false,
                        maintainAspectRatio: false,
                        responsiveAnimationDuration: 0,
                        animation: {
                            duration: 0,
                            onComplete: function () {
                                resolve(this.toBase64Image('image/jpg', 1));
                            }
                        }
                    },
                    plugins: {
                        datalabels: {display: false}
                    },
                };

                const _scope1_area_option = {
                    ..._common_option.global,
                    elements: {line: {borderWidth: 1}},
                    scales: {},
                    plugins: _common_option.plugins,
                    cutout: '76%'
                };

                if (!this.category1PieChartInstance) {
                    this.category1PieChartInstance = this.$chartjs.createChart(
                        document.getElementById('category1-chart-pie'),
                        {
                            type: 'doughnut',
                            data: _scope1_data,
                            options: _scope1_area_option
                        }
                    );
                } else {
                    this.$chartjs.updateChart(this.category1PieChartInstance, _scope1_data, _scope1_area_option);
                }
            });
        },
        drawCategory1PieChartImage() {
            return this.category1PieChartInstance.toBase64Image('image/jpg', 1);
        },
        async createCategory2ScorePage(doc, position_y) {
            doc.addPage();
            this.addHeader(doc, 2);
            position_y = this.firstElementSpacing;

            position_y = this.addTitle(doc, position_y, 1, this.$t('영역별 점수비교', this.report_lang));

            const _category1_area_chart = await this.generateCategory1ContraryAreaChartInstance();
            const _category1_score_box_size = this.pageContentWidth * 0.45;
            const _category1_score_box_height = _category1_score_box_size * 0.85;
            doc.setFillColor(...this.jsPDFOpt.card.fillColor);
            doc.rect(this.jsPDFOpt.margin.left, position_y, _category1_score_box_size, _category1_score_box_height, 'F');

            const _category2_score_chart_width = _category1_score_box_size * 0.8;
            const _category2_score_chart_height = _category1_score_box_height * 0.95;
            const _category2_score_chart_position_x = this.jsPDFOpt.margin.left + ((_category1_score_box_size - _category2_score_chart_width) / 2);
            const _category2_score_chart_position_y = position_y + ((_category1_score_box_height - _category2_score_chart_height) / 2);
            doc.addImage(_category1_area_chart, 'png', _category2_score_chart_position_x, _category2_score_chart_position_y, _category2_score_chart_width, _category2_score_chart_height);

            const score_0 = doc.splitTextToSize(0);
            const score_0_dim = doc.getTextDimensions(score_0, {fontSize: 9});
            const score_100 = doc.splitTextToSize(100);
            const score_100_dim = doc.getTextDimensions(score_100, {fontSize: 9});

            const _category1_score_indicator_position_x = this.pageContentWidth * 0.6;
            const _category1_score_indicator_position_x_end = this.jsPDFOpt.margin.left + this.pageContentWidth - score_100_dim.w - 5;

            this.scoringInfo.category1.forEach((_category1, _category1_idx) => {
                const _category1_key = _category1.question_name_ko;
                const {avg, top} = this.benchMarkScore.category1[_category1_key];

                const _score_category1_name = doc.splitTextToSize(_category1.question_name);
                const _score_category1_name_dim = doc.getTextDimensions(_score_category1_name, {fontSize: 8.5});

                this.setFont(doc, null, null, 'medium');
                doc.setFontSize(8.5);
                const _score_category1_position_x = _category1_score_indicator_position_x - score_0_dim.w - 5;
                const _score_category1_position_y = position_y + _score_category1_name_dim.h + (_category1_score_box_height * ((_category1_idx) / this.scoringInfo.category1.length) * 1);
                doc.text(_score_category1_name, _score_category1_position_x, _score_category1_position_y);


                const _score_category1_x_axis_position_x = _score_category1_position_x + score_0_dim.w + 3;
                const _score_category1_x_axis_position_y = _score_category1_position_y + _score_category1_name_dim.h + 8;
                doc.setLineDashPattern([3, 2], 1);
                doc.setLineWidth(0.35);
                doc.setDrawColor('#c8c8c8');
                doc.line(_score_category1_x_axis_position_x, _score_category1_x_axis_position_y, _category1_score_indicator_position_x_end, _score_category1_x_axis_position_y);
                doc.setLineDashPattern([], 0);

                this.setFont(doc, null, null, 'normal');
                doc.setFontSize(9);
                const _category1_score_0_position_y = _score_category1_x_axis_position_y + (score_0_dim.h / 2);
                doc.text(score_0, _score_category1_position_x, _category1_score_0_position_y);
                doc.text(score_100, _category1_score_indicator_position_x_end + score_100_dim.w - 7, _category1_score_0_position_y);

                const _score_indicator_position_x = this.getXFromScore(_category1_score_indicator_position_x, _category1_score_indicator_position_x_end, _category1['환산_점수']);
                this.drawScoreIndicator(doc, _score_indicator_position_x, _score_category1_x_axis_position_y, _category1['환산_점수'], {
                    size: 4,
                    indicator_fill_color: [183, 62, 110],
                    indicator_border_color: [194, 24, 91]
                });

                const _benchmark_score_avg_indicator_common_opt = {label_position: 'bottom', label_font_size: 8.5};
                const _benchmark_score_avg_indicator_common_avg = {
                    ..._benchmark_score_avg_indicator_common_opt,
                    indicator_fill_color: [136, 136, 136, 0.7],
                    indicator_border_color: [136, 136, 136],
                    indicator_line_style: 'dotted',
                    fill_background: false
                };
                const _benchmark_score_avg_indicator_position_x = this.getXFromScore(_category1_score_indicator_position_x, _category1_score_indicator_position_x_end, avg);
                this.drawScoreIndicator(doc, _benchmark_score_avg_indicator_position_x, _score_category1_x_axis_position_y, avg, _benchmark_score_avg_indicator_common_avg);

                const _benchmark_score_avg_indicator_common_top = {
                    ..._benchmark_score_avg_indicator_common_opt,
                    indicator_fill_color: [196, 169, 134, 0.7],
                    indicator_border_color: [196, 169, 134],
                    indicator_line_style: 'dashed',
                    fill_background: false
                };
                const _benchmark_score_top_indicator_position_x = this.getXFromScore(_category1_score_indicator_position_x, _category1_score_indicator_position_x_end, top);
                this.drawScoreIndicator(doc, _benchmark_score_top_indicator_position_x, _score_category1_x_axis_position_y, top, _benchmark_score_avg_indicator_common_top);
            });

            position_y += _category1_score_box_height + this.jsPDFOpt.spacing.section_xs;


            // 세부 영역별 점수 진단
            // this.section_score_description
            const _category1_section_score_desc_padding = 5;
            const _category1_section_score_desc_box_position_x = this.jsPDFOpt.margin.left;

            const _category1_section_score_desc_area_width = this.pageContentWidth - (_category1_section_score_desc_padding * 2);

            this.setFont(doc, 'table_td', null, 'normal');
            doc.setFontSize(11);
            doc.setLineHeightFactor(1.55);
            const _category1_score_description = doc.splitTextToSize(this.section_score_description, _category1_section_score_desc_area_width);
            const _category1_score_desc_dim = doc.getTextDimensions(_category1_score_description);

            doc.setLineWidth(0.5);
            doc.setFillColor(...this.jsPDFOpt.card.fillColor);
            doc.setDrawColor(224, 224, 224);
            const _category1_score_desc_box_height = _category1_score_desc_dim.h + (_category1_section_score_desc_padding * 3);
            const _category1_score_desc_box_width = this.pageContentWidth;
            doc.rect(_category1_section_score_desc_box_position_x, position_y, _category1_score_desc_box_width, _category1_score_desc_box_height, 'FD');

            position_y += 11 - 1.55;
            const _subs_composition_area_position_x = _category1_section_score_desc_box_position_x + _category1_section_score_desc_padding; // _category1_section_score_desc_box_position_x + ((_category1_score_desc_box_width - _category1_score_desc_dim.w) / 2) + _category1_section_score_desc_padding
            const _subs_composition_area_position_y = position_y + ((_category1_score_desc_box_height - _category1_score_desc_dim.h) / 3);
            doc.text(_category1_score_description, _subs_composition_area_position_x, _subs_composition_area_position_y);
            doc.setLineHeightFactor(1.15);

            position_y += _category1_score_desc_box_height + this.jsPDFOpt.spacing.section_xs;
            position_y = this.addTitle(doc, position_y, 2, this.$t('세부 영역별 점수 비교', this.report_lang), {skip_divider: true});

            let _cat3_padding = 10;
            let _cat3_posistion_y = position_y;
            let _cat3_posistion_x_left = this.jsPDFOpt.margin.left;
            let _cat3_posistion_x_right = this.jsPDFOpt.margin.left + (this.pageContentWidth / 2) + _cat3_padding;
            let _cat3_score_box_width = (this.pageContentWidth / 2) - _cat3_padding;
            let _cat3_score_box_height = 55;

            this.scoringInfo.category3.forEach(({category1_question_name, category3}) => {
                if (this.checkNeedNewPage(doc, _cat3_posistion_y, 60)) {
                    _cat3_posistion_y = this.firstElementSpacing;
                }
                // Category1 타이틀 추가
                _cat3_posistion_y = this.addTitle(doc, _cat3_posistion_y, 3, category1_question_name) + this.jsPDFOpt.spacing.title_xs;


                const _category3_chart_box_padding = 5;
                const _category3_chart_box_height = _cat3_score_box_height - (_category3_chart_box_padding * 2);
                const _category3_chart_box_width = _cat3_score_box_width - (_category3_chart_box_padding * 2);

                const _category3_label_area_width_spacing = this.report_lang === 'ko' ? 0 : 9;
                const max_text_width = Math.max(
                    doc.getTextDimensions(doc.splitTextToSize(this.benchMarkScoreLabel('avg'), {fontSize: 9.5})).w,
                    doc.getTextDimensions(doc.splitTextToSize(this.benchMarkScoreLabel('top'), {fontSize: 9.5})).w
                );
                const _category3_label_area_width = max_text_width + _category3_label_area_width_spacing;

                let _label_company_name = '';
                for (const category3LabelAreaWidthElement of this.headerInfo.company_name) {
                    if (doc.getTextDimensions(doc.splitTextToSize(_label_company_name + category3LabelAreaWidthElement), {fontSize: 9.5}).w > _category3_label_area_width) {
                        _label_company_name += '...';
                        break;
                    }
                    _label_company_name += category3LabelAreaWidthElement;
                }


                const _category3_chart_bar_area_width = _category3_chart_box_width - _category3_label_area_width - _category3_chart_box_padding;

                this.setFont(doc, null, null, 'medium');


                category3.forEach((_cat3, _cat3_idx) => {
                    let {category3_question_name, category3_question_name_kr, not_applicable, score} = _cat3;
                    const _category3_name = doc.splitTextToSize(category3_question_name);
                    const _category3_name_dim = doc.getTextDimensions(_category3_name, {fontSize: 10});

                    let [avg, top, bm_not_applicable] = [0, 0, false];
                    if (this.benchMarkScore.category3[category3_question_name_kr]) {
                        const _benchmark_store = this.benchMarkScore.category3[category3_question_name_kr];
                        avg = _benchmark_store.avg;
                        top = _benchmark_store.top;
                        // 
                        if (avg === 'N/A' || top === 'N/A') {
                            bm_not_applicable = true;
                        }
                    } else {
                        bm_not_applicable = true;
                    }

                    const _category3_chart_labels = [
                        {
                            label: doc.splitTextToSize(this.benchMarkScoreLabel('avg')),
                            value: avg,
                            is_na: bm_not_applicable,
                            fillColor: [215, 204, 200],
                            textColor: '#424242',
                            fontWeight: 'normal'
                        },
                        {
                            label: doc.splitTextToSize(this.benchMarkScoreLabel('top')),
                            value: top,
                            is_na: bm_not_applicable,
                            fillColor: [189, 189, 189],
                            textColor: '#424242',
                            fontWeight: 'normal'
                        },
                        {
                            label: _label_company_name,
                            value: score,
                            is_na: not_applicable,
                            fillColor: [13, 71, 161],
                            textColor: '#ffffff',
                            fontWeight: 'semibold'
                        }
                    ];


                    if (this.checkNeedNewPage(doc, _cat3_posistion_y, _cat3_score_box_height + _category3_name_dim.h)) {
                        _cat3_posistion_y = this.firstElementSpacing;
                    }

                    let _cat3_score_position_x = _cat3_idx % 2 === 0 ? _cat3_posistion_x_left : _cat3_posistion_x_right;
                    this.setFont(doc, null, null, 'normal');
                    doc.setFontSize(10);

                    if (_cat3_idx % 2 === 0) {
                        _cat3_posistion_y += _category3_name_dim.h * 1.75;
                    }

                    // Category3 타이틀 추가
                    doc.text(_category3_name, _cat3_score_position_x, _cat3_posistion_y);

                    // Category3 차트 박스 그리기
                    doc.setLineWidth(0.5);
                    doc.setDrawColor(224, 224, 224);
                    const _category3_chart_box_position_y = _cat3_posistion_y + 5;
                    doc.rect(_cat3_score_position_x, _category3_chart_box_position_y, _cat3_score_box_width, _cat3_score_box_height, 'D');

                    // Category3 차트 박스 내 영역 그리기
                    doc.setDrawColor(255, 255, 255);
                    const _category3_chart_area_position_x = _cat3_score_position_x + _category3_chart_box_padding;
                    const _category3_chart_area_position_y = _category3_chart_box_position_y + _category3_chart_box_padding;
                    doc.rect(_category3_chart_area_position_x, _category3_chart_area_position_y, _category3_chart_box_width, _category3_chart_box_height, 'D');

                    // Category3 차트 박스 내 X축 그리기
                    const _category3_chart_y_axis_position_x = _category3_chart_area_position_x + _category3_label_area_width;
                    const _category3_chart_y_axis_position_y_end = _category3_chart_area_position_y + _category3_chart_box_height;
                    doc.setLineWidth(0.5);
                    doc.setDrawColor('#E0E0E0');
                    doc.line(_category3_chart_y_axis_position_x, _category3_chart_area_position_y, _category3_chart_y_axis_position_x, _category3_chart_y_axis_position_y_end);

                    let _cat_label_position_y = _category3_chart_area_position_y;
                    _category3_chart_labels.forEach((_cat_label) => {
                        // Category3 차트 - 라벨 타이틀 추가
                        const _cat_label_dim = doc.getTextDimensions(_cat_label.label, {fontSize: 8});
                        const _cat_label_bar_position_x = _category3_chart_y_axis_position_x - _cat_label_dim.w - _category3_chart_box_padding;
                        this.setFont(doc, null, null, _cat_label.fontWeight);
                        doc.setFontSize(8);
                        _cat_label_position_y += _cat_label_dim.h + 6.5;
                        doc.text(_cat_label.label, _cat_label_bar_position_x, _cat_label_position_y);

                        const _category3_chart_bar_height = 7;
                        const _category3_chart_bar_posistion_y = _cat_label_position_y - 5.5;
                        if (_cat_label.value || typeof _cat_label.is_na !== 'undefined') {
                            // Category3 차트 - 막대 차트 추가
                            const _category3_chart_bar_posistion_x_end = _cat_label.is_na === true ? 0 : _category3_chart_bar_area_width * (_cat_label.value / 100);
                            doc.setFillColor(..._cat_label.fillColor);
                            doc.rect(_category3_chart_y_axis_position_x, _category3_chart_bar_posistion_y, _category3_chart_bar_posistion_x_end, _category3_chart_bar_height, 'F');
                            const _category3_chart_bar_width = _cat_label.is_na ? 0 : _category3_chart_bar_posistion_x_end - _category3_chart_y_axis_position_x;

                            let _category3_chart_datalabel = _cat_label.is_na ? 'N/A' : _cat_label.value;
                            _category3_chart_datalabel = doc.splitTextToSize(_category3_chart_datalabel);
                            const _category3_chart_datalabel_dim = doc.getTextDimensions(_category3_chart_datalabel, {fontSize: 7});
                            const _category3_chart_datalabel_position_x = _cat_label.is_na || _cat_label.value === 0
                                ? 5
                                : _cat_label.value < 20
                                    ? _category3_chart_y_axis_position_x + _category3_chart_bar_width + _category3_chart_datalabel_dim.w + 15
                                    : _category3_chart_y_axis_position_x + _category3_chart_bar_width - _category3_chart_datalabel_dim.w;

                            // Category3 차트 - 데이터라벨 추가
                            this.setFont(doc, null, null, _cat_label.fontWeight);
                            if (_cat_label.is_na || _category3_chart_datalabel == 0 || _cat_label.value < 20) {
                                doc.setTextColor('#424242');
                            } else {
                                doc.setTextColor(_cat_label.textColor);
                            }

                            doc.setFontSize(7);
                            const _category3_chart_datalabel_position_y = _category3_chart_bar_posistion_y + _category3_chart_datalabel_dim.h + 0.2;
                            doc.text(_category3_chart_datalabel, _category3_chart_y_axis_position_x + (_category3_chart_datalabel_position_x / 2), _category3_chart_datalabel_position_y);
                        }
                    });

                    if (!this.checkNeedNewPage(doc, _cat3_posistion_y, _cat3_score_box_height) && (_cat3_idx % 2 === 1 || (category3.length - 1 === _cat3_idx))) {
                        _cat3_posistion_y += _category3_name_dim.h + _cat3_score_box_height + 5; // + this.jsPDFOpt.spacing.title_xs
                    } else if (this.checkNeedNewPage(doc, _cat3_posistion_y, _cat3_score_box_height)) {
                        _cat3_posistion_y = this.firstElementSpacing;
                    }
                });

                _cat3_posistion_y += this.jsPDFOpt.spacing.section_xs;
            });

            position_y += _cat3_posistion_y + this.jsPDFOpt.spacing.section_md;
            return position_y;
        },
        generatePartialSummaryPage(doc, position_y) {
            doc.addPage();
            this.addHeader(doc);
            position_y = this.firstElementSpacing;

            position_y = this.addTitle(doc, position_y, 1, this.$t('영역별 평가결과 요약', this.report_lang));

            this.setFont(doc, 'table_td', null, 'semibold');
            doc.setFontSize(12);
            let _partial_score_guide_padding = 10;
            let _partial_score_guide_text = this.report_lang === 'ko'
                ? `${this.companyInfo['회사명']}의 영역별 점수와 세부 항목별 점수는 다음과 같습니다.`
                : this.report_lang === 'en'
                    ? `The scores by area and the detailed scores for ${this.companyInfo['회사명']} are as follows.`
                    : `${this.companyInfo['회사명']} 各领域的得分和具体项目的得分如下。`;
            _partial_score_guide_text = doc.splitTextToSize(_partial_score_guide_text, this.pageContentWidth - (_partial_score_guide_padding * 2));

            let _partial_score_guide_text_dim = doc.getTextDimensions(_partial_score_guide_text);
            let _partial_score_guide_card_height = _partial_score_guide_text_dim.h + (_partial_score_guide_padding * 2);
            doc.setFillColor(...this.jsPDFOpt.card.fillColor);
            doc.rect(this.jsPDFOpt.margin.left, position_y, this.pageContentWidth, _partial_score_guide_card_height, 'F');

            let _partial_score_guide_text_position_y = position_y + (_partial_score_guide_card_height - _partial_score_guide_text_dim.h) - 1;
            doc.text(_partial_score_guide_text, this.jsPDFOpt.margin.left + _partial_score_guide_padding, _partial_score_guide_text_position_y);

            position_y += _partial_score_guide_card_height + this.jsPDFOpt.spacing.section_xs;

            // 테이블 범주
            const _fill_color = {min: '#FFF3E0', max: '#d3e4f1', na: '#E0E0E0'};
            let legends_ko = ['최저점 항목', '최고점 항목', '해당없음, 평가제외'];
            let _category3_table_legend_ele = (this.pageContentWidth / 3);
            let _longest_legend_position_x = this.report_lang === 'ko'
                ? this.jsPDFOpt.margin.left + (this.pageContentWidth / 2) - 30
                : this.jsPDFOpt.margin.left;
            let _legend_mark_width = 20;

            Object.values(_fill_color).forEach((_fill_color_ele, _fill_color_idx) => {
                this.setFont(doc, 'table_td', null, 'normal');
                doc.setFontSize(9.5);
                let _legend_name = 2 > _fill_color_idx
                    ? `${this.$t(legends_ko[_fill_color_idx], this.report_lang)}, `
                    : this.$t(legends_ko[_fill_color_idx], this.report_lang);
                _legend_name = doc.splitTextToSize(_legend_name, _category3_table_legend_ele);
                let _legend_name_dim = doc.getTextDimensions(_legend_name);

                doc.setFillColor(Object.values(_fill_color)[_fill_color_idx]);
                doc.rect(_longest_legend_position_x, position_y - 6.6, _legend_mark_width, _legend_name_dim.h, 'F');

                let _legend_name_position_x = _longest_legend_position_x + _legend_mark_width + 2;
                doc.text(`: ${_legend_name}`, _legend_name_position_x, position_y);
                _longest_legend_position_x += _legend_mark_width + _legend_name_dim.w + 5 + 8;
            });

            position_y += 15;

            const _category3_group_left = this.scoringInfo.category3.filter(({category1_question_name_ko}) => ['2. 윤리', '1. 인권 및 노동'].includes(category1_question_name_ko));
            const _category3_group_right = this.scoringInfo.category3.filter(({category1_question_name_ko}) => ['3. 환경', '4. 안전'].includes(category1_question_name_ko));
            let _category3_group_left_postion_y = position_y;
            let _category3_group_right_postion_y = position_y;

            const returnCellFillColor = (min, max, na) => {
                return na ? _fill_color.na
                    : !min && !max && !na
                        ? null
                        : min
                            ? _fill_color.min
                            : _fill_color.max;
            };

            const _category3_score_table_common_header = [
                {
                    content: this.$t('중분류', this.report_lang),
                    styles: {
                        ...this.tableStyles.th,
                        fontSize: this.report_lang === 'ko' ? 10 : 9.5,
                        cellPadding: {top: 5.5, right: 5, bottom: 1, left: 5}
                    }
                },
                {
                    content: this.$t('점수', this.report_lang),
                    styles: {
                        ...this.tableStyles.th,
                        fontSize: this.report_lang === 'ko' ? 10 : 9.5,
                        cellPadding: {top: 5.5, right: 5, bottom: 1, left: 5}
                    }
                },
            ];

            const _category3_score_table_common_bodyStyle = {
                ...this.tableStyles.td,
                fontSize: this.report_lang === 'ko' ? 8.5 : 8,
                minCellHeight: 11,
                cellPadding: {top: 5, right: 5, bottom: 1.5, left: 5}
            };

            for (const _category3 of _category3_group_left) {
                const _category3_table_left = this.jsPDFOpt.margin.left;

                const {category1_question_name, category1_score} = _category3;
                _category3_group_left_postion_y = this.addTitle(doc, _category3_group_left_postion_y, 3, `${category1_question_name}:  ${category1_score} ${this.$t('점', this.report_lang)} `, {
                    skip_divider: true,
                    no_margin: true
                });

                const _category3_score_table_body = _category3.category3.map(({
                    category3_question_name,
                    score,
                    min,
                    max,
                    not_applicable
                }) => ([
                    {
                        content: category3_question_name,
                        styles: {fillColor: returnCellFillColor(min, max, not_applicable)}
                    },
                    {
                        content: not_applicable ? 'N/A' : score,
                        styles: {fillColor: returnCellFillColor(min, max, not_applicable)}
                    }
                ]));

                _category3_score_table_body.unshift(_category3_score_table_common_header);

                autoTable(doc, {
                    theme: 'grid',
                    startY: _category3_group_left_postion_y,
                    tableWidth: (this.pageContentWidth / 2) - 5,
                    showHead: 'everyPage',
                    rowPageBreak: 'avoid',
                    margin: {...this.jsPDFOpt.margin, top: this.firstElementSpacing, left: _category3_table_left},
                    styles: {...this.tableStyles.global, halign: 'center', valign: 'middle'},
                    bodyStyles: _category3_score_table_common_bodyStyle,
                    body: _category3_score_table_body,
                    didDrawPage: (HookData) => {
                        this.addHeader(HookData.doc);
                    }
                });


                _category3_group_left_postion_y = doc.lastAutoTable.finalY + this.jsPDFOpt.spacing.section_xs;
            }

            const _category3_table_right = (this.pageContentWidth / 2) + 5 + this.jsPDFOpt.margin.left;
            for (const _category3 of _category3_group_right) {
                const {category1_question_name, category1_score} = _category3;
                let category1_question_name_score = `${category1_question_name}: ${category1_score} ${this.$t('점', this.report_lang)}`;
                _category3_group_right_postion_y = this.addTitle(doc, _category3_group_right_postion_y, 3, category1_question_name_score, {
                    skip_divider: true,
                    no_margin: true,
                    position_x: _category3_table_right
                });

                const _category3_score_table_body = _category3.category3.map(({
                    category3_question_name,
                    score,
                    min,
                    max,
                    not_applicable
                }) => ([
                    {
                        content: category3_question_name,
                        styles: {fillColor: returnCellFillColor(min, max, not_applicable)}
                    },
                    {
                        content: not_applicable ? 'N/A' : score,
                        styles: {fillColor: returnCellFillColor(min, max, not_applicable)}
                    },
                ]));

                _category3_score_table_body.unshift(_category3_score_table_common_header);

                autoTable(doc, {
                    theme: 'grid',
                    startY: _category3_group_right_postion_y,
                    tableWidth: (this.pageContentWidth / 2) - 5,
                    showHead: 'everyPage',
                    rowPageBreak: 'avoid',
                    margin: {...this.jsPDFOpt.margin, top: this.firstElementSpacing, left: _category3_table_right},
                    styles: {...this.tableStyles.global, halign: 'center', valign: 'middle'},
                    bodyStyles: _category3_score_table_common_bodyStyle,
                    body: _category3_score_table_body,
                    didDrawPage: (HookData) => {
                        this.addHeader(HookData.doc);
                    }
                });

                _category3_group_right_postion_y = doc.lastAutoTable.finalY + this.jsPDFOpt.spacing.section_xs;
            }

            return position_y;
        },
        async generateCategory3AnalysisPage(doc, position_y) {
            doc.addPage();
            this.addHeader(doc);
            position_y = this.firstElementSpacing;

            // 세부 영역별 평가 결과
            position_y = this.addTitle(doc, position_y, 1, '세부 영역별 평가 결과');

            // 세부 영역별 점수
            for (const [category3_idx, _category3] of this.scoringInfo.category3.entries()) {
                if (category3_idx > 0) {
                    doc.addPage();
                    this.addHeader(doc, 2);
                    position_y = this.firstElementSpacing;
                }

                const {category1_question_name, category1_question_name_ko} = _category3;

                position_y = this.addTitle(doc, position_y, 2, category1_question_name, {
                    skip_divider: true,
                    no_padding: true
                }) - 5;
                position_y = this.addTitle(doc, position_y, 3, '영역별 평가 결과', {
                    skip_divider: true,
                    no_margin: true,
                    no_padding: true
                });

                const _category3_score_box_padding = 5;
                const _category1_score_box_width = this.pageContentWidth;
                const _category1_score_box_half_position_y = this.jsPDFOpt.margin.left + ((this.pageContentWidth / 2) - _category3_score_box_padding);
                const _category1_score_box_half_width = ((this.pageContentWidth / 2) - _category3_score_box_padding);
                const _category1_score_box_height = 85; // 90 // 100
                const _category1_score_box_inner_position_y_begin = position_y + _category3_score_box_padding;
                const _category1_score_box_inner_position_y_end = _category1_score_box_inner_position_y_begin + _category1_score_box_height - (_category3_score_box_padding * 2);

                doc.setFillColor(...this.jsPDFOpt.card.fillColor);
                doc.setLineWidth(this.jsPDFOpt.card.lineWidth * 2);
                doc.setDrawColor(this.jsPDFOpt.card.borderColor);
                doc.rect(this.jsPDFOpt.margin.left, position_y, _category1_score_box_width, _category1_score_box_height, 'FD');

                doc.setLineWidth(0.75);
                doc.setDrawColor('#E0E0E0');
                doc.line(_category1_score_box_half_position_y, _category1_score_box_inner_position_y_begin, _category1_score_box_half_position_y, _category1_score_box_inner_position_y_end);

                const _category3_category1_question_name = doc.splitTextToSize(`${_category3.category1_question_name} ${this.$t('총점', this.report_lang)}`, _category1_score_box_half_width - 10);
                const _category3_category1_question_name_dim = doc.getTextDimensions(_category3_category1_question_name);
                const _category3_category1_question_name_position_x = this.jsPDFOpt.margin.left + 10;
                const _category3_category1_question_name_position_y = _category1_score_box_inner_position_y_begin + (_category3_score_box_padding * 2);
                doc.text(_category3_category1_question_name, _category3_category1_question_name_position_x, _category3_category1_question_name_position_y);
                const _category3_category1_question_name_position_y_end = _category3_category1_question_name_position_y + _category3_category1_question_name_dim.h;

                doc.setFontSize(30);
                let _category3_category1_question_score = `${_category3.category1_score} ${this.$t('점', this.report_lang)}`;
                _category3_category1_question_score = doc.splitTextToSize(_category3_category1_question_score, _category1_score_box_half_width);
                const _category3_category1_question_score_dim = doc.getTextDimensions(_category3_category1_question_score);
                const _category3_category1_question_score_position_x = this.jsPDFOpt.margin.left + ((_category1_score_box_half_width - _category3_category1_question_score_dim.w) / 2);
                const _category3_category1_question_score_position_y = _category3_category1_question_name_position_y_end + ((_category1_score_box_inner_position_y_end - _category3_category1_question_name_position_y_end) / 2);
                doc.text(_category3_category1_question_score, _category3_category1_question_score_position_x, _category3_category1_question_score_position_y);

                const _category3_category1_area_chart_height = this.report_lang === 'ca'
                    ? _category1_score_box_height * 0.85
                    : _category1_score_box_height * 0.8;
                const _category3_category1_area_chart_width = this.report_lang === 'ca' || this.report_lang === 'ko'
                    ? _category3_category1_area_chart_height * 1.45
                    : _category3_category1_area_chart_height * 1.8;

                const _category3_category1_chart_position_x = this.jsPDFOpt.margin.left + _category1_score_box_half_width + ((_category1_score_box_half_width - _category3_category1_area_chart_width) / 2); // + (_category3_score_box_padding * 1)
                const _category3_category1_chart_position_y = _category1_score_box_inner_position_y_begin + ((_category1_score_box_height - _category3_category1_area_chart_height) / 2) - _category3_score_box_padding;
                const _cataory1_chart_area = await this.generatecategory1AreaChartInstance(null, {
                    emphasis: true,
                    emphasis_label: this.splitByManagement(category1_question_name).trim()
                });
                if (this.category1AreaChartInstance) {
                    this.category1AreaChartInstance.destroy();
                    this.category1AreaChartInstance = null;
                }

                doc.addImage(_cataory1_chart_area, 'png', _category3_category1_chart_position_x, _category3_category1_chart_position_y, _category3_category1_area_chart_width, _category3_category1_area_chart_height);
                position_y += _category1_score_box_height + this.jsPDFOpt.spacing.section_xs - 5;

                if (this.checkNeedNewPage(doc, position_y, 100)) {
                    position_y = this.firstElementSpacing;
                }

                this.setFont(doc, 'table_td', null);
                doc.setFontSize(10.5);
                const _category1_description_padding = 10;
                const _category1_description_text = doc.splitTextToSize(this.category1_description[category1_question_name_ko], this.pageContentWidth - (_category1_description_padding * 2));
                const _category1_description_text_dim = doc.getTextDimensions(_category1_description_text);
                const _category1_description_box_height = _category1_description_text_dim.h + (_category1_description_padding * 2);
                const _category1_description_position_y = position_y + _category1_description_padding * 1.55;

                doc.setLineWidth(this.jsPDFOpt.card.lineWidth);
                doc.setDrawColor(this.jsPDFOpt.card.borderColor);
                doc.setFillColor(...this.jsPDFOpt.card.fillColor);
                doc.rect(this.jsPDFOpt.margin.left, position_y, this.pageContentWidth, _category1_description_box_height, 'FD');
                doc.text(_category1_description_text, this.jsPDFOpt.margin.left + _category1_description_padding, _category1_description_position_y, {lineHeightFactor: 1.3});
                position_y += _category1_description_box_height + this.jsPDFOpt.spacing.section_sm;

                position_y = this.addTitle(doc, position_y, 3, this.$t('세부 문항별 평가결과', this.report_lang), {
                    skip_divider: true,
                    no_margin: true,
                    footnote: this.report_lang === 'ko' ? '중분류 점수는 100 점 만점 기준 환산 값' : null
                });
                const y_axis_line_padding = 4.5;
                const _filtered_category3_score = _category3.category3.filter(({not_applicable}) => not_applicable === false);
                let _category3_score_chart_area_position_x_begin = this.jsPDFOpt.margin.left;
                let _category3_score_chart_area_position_x_end = this.jsPDFOpt.margin.left + this.pageContentWidth;
                let _category3_score_chart_width = _category3_score_chart_area_position_x_end - _category3_score_chart_area_position_x_begin;
                let _category3_score_chart_inner_width = _category3_score_chart_width - (y_axis_line_padding * 4);
                let _category3_score_chart_label_width = _category3_score_chart_inner_width * 0.35;
                let _category3_score_chart_label_position_x_begin = _category3_score_chart_area_position_x_begin + (y_axis_line_padding * 2);
                let _category3_score_chart_label_position_x_end = _category3_score_chart_label_position_x_begin + _category3_score_chart_label_width - y_axis_line_padding;
                let _category3_score_chart_y_axis_position_x = _category3_score_chart_label_position_x_end + y_axis_line_padding;
                let _category3_score_chart_bar_area_width = (_category3_score_chart_inner_width * 0.65) - (y_axis_line_padding * 4);
                let _category3_score_chart_bar_position_x_begin = _category3_score_chart_label_position_x_end + y_axis_line_padding;
                let _category3_score_chart_bar_thickness = 6;

                let _category3_score_label_total_height = _filtered_category3_score.reduce((_labels_total_height, {category3_question_name}) => {
                    this.setFont(doc, 'table_td', null, 'medium');
                    doc.setFontSize(9.5);
                    const _label = doc.splitTextToSize(category3_question_name, _category3_score_chart_label_width);
                    _labels_total_height += doc.getTextDimensions(_label).h / _label.length;
                    return _labels_total_height;
                }, 0);

                _category3_score_label_total_height += (_filtered_category3_score.length - 1) * (y_axis_line_padding * 2);

                let _category3_score_chart_area_height = _category3_score_label_total_height + (y_axis_line_padding * 2); // bar 시리즈에 위, 아래 패딩 추가
                let _category3_score_chart_height = _category3_score_chart_area_height + (y_axis_line_padding * 3); // 차트 내부 영역 - 높이에 위, 아래 패딩 추가
                let _category3_score_chart_position_y_begin = position_y;
                let _category3_score_chart_area_position_y_begin = _category3_score_chart_position_y_begin + y_axis_line_padding;
                let _category3_score_chart_area_position_y_end = _category3_score_chart_area_position_y_begin + _category3_score_chart_area_height + y_axis_line_padding;

                let _category3_bar_position_y = _category3_score_chart_area_position_y_begin + (y_axis_line_padding * 2.5);
                _filtered_category3_score.forEach(({category3_question_name, score, not_applicable}) => {
                    // label 추가
                    const _category3_barChart_label = doc.splitTextToSize(category3_question_name, _category3_score_chart_label_width);
                    const _category3_barChart_label_dim = doc.getTextDimensions(_category3_barChart_label);
                    this.setFont(doc, 'table_td', null, 'medium');
                    doc.setFontSize(9.5);

                    if (_category3_barChart_label.length > 1) {
                        doc.text(_category3_barChart_label, _category3_score_chart_label_position_x_end, _category3_bar_position_y - 5, {align: 'right'});
                    } else {
                        doc.text(_category3_barChart_label, _category3_score_chart_label_position_x_end, _category3_bar_position_y, {align: 'right'});
                    }

                    // score bar 추가
                    doc.setFillColor(0, 105, 177);
                    const _category3_barChart_bar_width = not_applicable ? 0 : (score / 100) * _category3_score_chart_bar_area_width;
                    const _category3_barChart_label_height = _category3_barChart_label.length > 1 ? _category3_barChart_label_dim.h * 0.5 : _category3_barChart_label_dim.h;
                    const _category3_barChart_bar_position_y = _category3_bar_position_y + (_category3_barChart_label_height - _category3_score_chart_bar_thickness) / 2 - y_axis_line_padding - 0.75;
                    const _category3_barChart_bar_position_x_end = _category3_score_chart_bar_position_x_begin + _category3_barChart_bar_width;
                    doc.rect(_category3_score_chart_bar_position_x_begin, _category3_barChart_bar_position_y, _category3_barChart_bar_width, _category3_score_chart_bar_thickness, 'F');

                    // score 추가
                    this.setFont(doc, 'table_td', null, 'medium');
                    doc.setFontSize(9.5);
                    const _category3_barChart_score = doc.splitTextToSize(not_applicable ? 'N/A' : score, 30);
                    const _category3_barChart_score_dim = doc.getTextDimensions(_category3_barChart_score);
                    doc.text(_category3_barChart_score, _category3_barChart_bar_position_x_end + y_axis_line_padding, _category3_barChart_bar_position_y + ((_category3_score_chart_bar_thickness + _category3_barChart_score_dim.h) / 2) - 1);
                    _category3_bar_position_y += (y_axis_line_padding * 2) + _category3_barChart_label_height;
                });

                // 라벨과 바의 분기 line
                doc.setLineWidth(0.35);
                doc.setDrawColor('#c8c8c8');
                doc.line(_category3_score_chart_y_axis_position_x, _category3_score_chart_area_position_y_begin, _category3_score_chart_y_axis_position_x, _category3_score_chart_area_position_y_end);

                // category3 bar 차트 Area
                doc.setLineWidth(this.jsPDFOpt.card.lineWidth);
                doc.setDrawColor(this.jsPDFOpt.card.borderColor);
                doc.rect(_category3_score_chart_area_position_x_begin, _category3_score_chart_position_y_begin, _category3_score_chart_width, _category3_score_chart_height, 'D');

                if (this.report_lang !== 'ko') {
                    this.setFont(doc, 'footnote');
                    const _category3_barChart_footnote = doc.splitTextToSize(this.$t('중분류 점수는 100 점 만점 기준 환산 값', this.report_lang), this.pageContentWidth);
                    const _category3_barChart_footnote_dim = doc.getTextDimensions(_category3_barChart_footnote);
                    const _category3_barChart_footnote_position_y = _category3_score_chart_position_y_begin + _category3_score_chart_height + _category3_barChart_footnote_dim.h + 5;

                    doc.text(_category3_barChart_footnote, this.jsPDFOpt.margin.left + this.pageContentWidth, _category3_barChart_footnote_position_y, {align: 'right'});
                    position_y += _category3_barChart_footnote_dim.h + 5;
                }

                position_y += _category3_score_chart_height + this.jsPDFOpt.spacing.section_md;
                if (this.checkNeedNewPage(doc, position_y, 40)) {
                    position_y = this.firstElementSpacing;
                }

                // 핵심지표 결과 테이블 범주
                let _longest_legend_position_x_weight = {ko: 28, en: 0, ca: 40};
                let legends_ko = ['충족', '일부항목 충족', '미충족', '해당없음'];
                const _fill_color = {'충족': '#0069aa', '일부항목 충족': '#fa7e14', '미충족': '#dc353c', '해당없음': '#BDBDBD'};
                let _category3_table_legend_ele = (this.pageContentWidth / 3);

                let _longest_legend_position_x = this.jsPDFOpt.margin.left + (this.pageContentWidth / 2) + _longest_legend_position_x_weight[this.report_lang];
                let _legend_mark_width = 7;
                let _legend_mark_position_y = position_y + 1;
                Object.values(_fill_color).forEach((_fill_color_ele, _fill_color_idx) => {
                    this.setFont(doc, 'table_td', null, 'normal');
                    doc.setFontSize(9);
                    let _legend_name = 3 > _fill_color_idx
                        ? `${this.$t(legends_ko[_fill_color_idx], this.report_lang)}, `
                        : this.$t(legends_ko[_fill_color_idx], this.report_lang);
                    _legend_name = doc.splitTextToSize(_legend_name, _category3_table_legend_ele);
                    let _legend_name_dim = doc.getTextDimensions(_legend_name);

                    doc.setFillColor(Object.values(_fill_color)[_fill_color_idx]);
                    doc.circle(_longest_legend_position_x, _legend_mark_position_y, 3, 'F');

                    let _legend_name_position_x = _longest_legend_position_x + _legend_mark_width - 1;
                    doc.text(`: ${_legend_name}`, _legend_name_position_x, _legend_mark_position_y + 2);
                    _longest_legend_position_x += _legend_mark_width + _legend_name_dim.w + 5 + 5;
                });

                position_y = this.addTitle(doc, position_y - 5, 3, this.$t('핵심지표 결과', this.report_lang), {
                    skip_divider: true,
                    no_margin: true
                });
                let _category1_key_indicator = this.scoring?.category1_importance_pd
                    .filter(({category1_question_code}) => category1_question_code === _category3.category1_question_code
                    );
                _category1_key_indicator = _category1_key_indicator.reduce((_key_indicators, _key_indicator) => {
                    let {
                        category3_question_code,
                        category3_question_name,
                        category3_question_name_ca,
                        category3_question_name_ea,
                        sub_code,
                        sub_name,
                        sub_name_ca,
                        sub_name_ea,
                        level
                    } = _key_indicator;

                    if (sub_code === 'Q4.12') {
                        sub_name = '최근 3년간 온실가스 간접 배출량(Scope 2) 관리 및 공개 여부';
                        sub_name_ca = '过去3年间接温室气体排放（范围2）的管理和公开情况';
                        sub_name_ea = 'Management and disclosure of indirect greenhouse gas emissions (Scope 2) over the past 3 years';
                    }

                    let _category3_question_name = this.report_lang === 'ko'
                        ? category3_question_name
                        : this.report_lang === 'ca' ? category3_question_name_ca : category3_question_name_ea;

                    let _sub_name = !sub_name
                        ? ' - '
                        : this.report_lang === 'ko'
                            ? sub_name
                            : this.report_lang === 'ca' ? sub_name_ca : sub_name_ea;


                    if (!_key_indicators[category3_question_code]) {
                        _key_indicators[category3_question_code] = {
                            category3_question_name: _category3_question_name,
                            count: 0,
                            indicators: []
                        };
                    }

                    _key_indicators[category3_question_code].count++;
                    _key_indicators[category3_question_code].indicators.push({
                        sub_code,
                        sub_name: _sub_name,
                        level: !level ? 'N/A' : level
                    });

                    return _key_indicators;
                }, {});
                _category1_key_indicator = Object.values(_category1_key_indicator);

                // 핵심지표 결과 테이블
                const category1_key_indicator_header = [
                    [
                        {content: this.$t('중분류', this.report_lang), styles: {cellWidth: this.pageContentWidth * 0.45}},
                        {content: this.$t('번호', this.report_lang), styles: {cellWidth: this.pageContentWidth * 0.1}},
                        {content: this.$t('내용', this.report_lang), styles: {cellWidth: this.pageContentWidth * 0.35}},
                        {content: this.$t('현황', this.report_lang), styles: {cellWidth: this.pageContentWidth * 0.1}},
                    ]
                ];
                let category1_key_indicators = _category1_key_indicator.reduce((_key_indicator_rows, _key_indicator_ele) => {
                    const {category3_question_name, count, indicators} = _key_indicator_ele;
                    indicators.forEach(({sub_code, sub_name, level}, indicators_idx) => {
                        const _indicator_style = {...this.tableStyles.td};
                        _indicator_style.textColor = level === null || level === 'N/A'
                            ? _fill_color['해당없음'] //'#E0E0E0'
                            : level === 'full'
                                ? _fill_color['충족'] : level === 'half' ? _fill_color['일부항목 충족'] : _fill_color['미충족'];
                        let _indicator_row = [
                            {content: sub_code, styles: this.tableStyles.td},
                            {content: sub_name, styles: this.tableStyles.td},
                            {
                                content: level === null ? 'N/A' : '●',
                                styles: _indicator_style
                            },
                        ];

                        if (indicators_idx < 1) {
                            _indicator_row.unshift({
                                content: category3_question_name, rowSpan: count, styles: this.tableStyles.td
                            });
                        }

                        _key_indicator_rows.push(_indicator_row);
                    });

                    return _key_indicator_rows;
                }, []);

                if (!category1_key_indicators.length) {
                    category1_key_indicators = [
                        [{
                            content: this.$t('해당사항 없음', this.report_lang), colSpan: 4, styles: this.tableStyles.td
                        }]
                    ];
                }

                autoTable(doc, {
                    theme: 'grid',
                    startY: position_y,
                    tableWidth: this.pageContentWidth,
                    showHead: 'everyPage',
                    rowPageBreak: 'avoid',
                    margin: {...this.jsPDFOpt.margin, top: this.firstElementSpacing, left: this.jsPDFOpt.margin.left},
                    styles: {...this.tableStyles.global, halign: 'center'},
                    headStyles: this.tableStyles.th,
                    head: category1_key_indicator_header,
                    body: category1_key_indicators,
                    didDrawPage: (HookData) => {
                        this.addHeader(HookData.doc);
                    }
                });
            }

            if (this.checkNeedNewPage(doc, position_y, 100)) {
                position_y = this.firstElementSpacing;
            }

            return position_y;
        },
        createFactorsPage(doc, position_y) {
            try {
                let _is_new_page = this.checkNeedNewPage(doc, position_y, this.pageContentHeight / 2); // 35
                if (_is_new_page) {
                    position_y = this.firstElementSpacing;
                }

                position_y = this.addTitle(doc, position_y, 1, this.$t('세부 평가결과', this.report_lang));

                this.factors.forEach((_cat1, _cat1_idx) => {
                    if (_cat1_idx > 0 && _cat1_idx < this.factors.length) {
                        position_y += this.jsPDFOpt.spacing.section_sm;
                    }


                    let _is_new_page = this.checkNeedNewPage(doc, position_y, 40); // 35
                    if (_is_new_page) {
                        position_y = this.firstElementSpacing;
                    }

                    position_y = this.addTitle(doc, position_y, 2, `${this.$t(_cat1.category1_question_name, this.report_lang)}`, {
                        skip_divider: true,
                        no_padding: true,
                        no_margin: true
                    });

                    _cat1.category3.forEach((_cat3) => {
                        // 문항별 Factors 테이블
                        _cat3.subs.forEach((_sub) => {
                            let _is_new_page = this.checkNeedNewPage(doc, position_y, 40); // 80 // 50 // 35
                            if (_is_new_page) {
                                position_y = this.firstElementSpacing;
                            }

                            let _factor_table_title = `[${_cat3.category3_question_name} - ${_sub.sub_code}]`;
                            if (_sub.sub_name) {
                                _factor_table_title += ` ${_sub.sub_name}`;
                            }
                            position_y = this.addTitle(doc, position_y, 4, _factor_table_title, {
                                skip_divider: true,
                                no_margin: true,
                                no_padding: true
                            });
                            position_y -= 3;
                            const _flatten_sub_evaluations = [..._sub.evaluations].reduce((_flatten, _sub_ev) => {
                                _flatten.push(..._sub_ev);
                                return _flatten;
                            }, []);

                            const _has_importance_evaluation_or_assessment = !!_flatten_sub_evaluations.find(({contentType}) => ['importance', 'assessment'].includes(contentType));
                            const _columnStyles = {
                                0: {
                                    cellWidth: this.report_lang === 'ko' ? this.pageContentWidth * 0.1 : this.pageContentWidth * 0.15,
                                    halign: 'center',
                                }
                            };

                            if (_has_importance_evaluation_or_assessment) {
                                _columnStyles[1] = {
                                    ...this.tableStyles.td,
                                    cellWidth: this.report_lang !== 'ko'
                                        ? this.pageContentWidth * 0.17
                                        : this.pageContentWidth * 0.12,
                                    valign: 'middle',
                                    halign: 'left'
                                };
                            }

                            autoTable(doc, {
                                theme: 'grid',
                                startY: position_y,
                                useCss: true,
                                margin: {...this.jsPDFOpt.margin, top: this.firstElementSpacing - 5},
                                body: _sub.evaluations,
                                rowPageBreak: 'avoid',
                                head: [[
                                    {content: this.$t('충족 여부', this.report_lang), dataKey: 'FactorState'},
                                    {
                                        content: this.$t('주요 사항', this.report_lang),
                                        dataKey: 'FactorContent',
                                        colSpan: (_has_importance_evaluation_or_assessment) ? 2 : 1
                                    }
                                ]],
                                styles: this.factorstables.global,
                                headStyles: this.factorstables.th,
                                bodyStyles: this.factorstables.td,
                                columnStyles: _columnStyles,
                                willDrawCell: (data) => {
                                    if (data.section === 'body') {
                                        const {cell} = data;
                                        if (data.column.dataKey === 0) {
                                            cell.text = [];
                                        } else if (data.column.dataKey === 1) {
                                            if (cell.raw.contentType === 'importance' && cell.raw.content) {
                                                cell.text = [];
                                            } else {
                                                cell.styles.cellPadding.right = 6.5;
                                                cell.styles.cellPadding.left = 6.5;
                                            }
                                        }
                                    }
                                },
                                didDrawCell: (data) => {
                                    if (data.section === 'body') {
                                        const {column, cell, doc} = data;
                                        if (column.dataKey === 0) {
                                            const textColor = '#ffffff';
                                            const _text = cell.raw.content;
                                            const bgColor = cell.raw.status ? '#2196f3' : '#ff5722';
                                            if (this.report_lang === 'ca') {
                                                cell.styles.font = this.jsPDFOpt.fontFamily_ca;
                                            } else {
                                                cell.styles.font = this.jsPDFOpt.fontFamily;
                                            }

                                            // Set text color
                                            doc.setTextColor(textColor);
                                            doc.setFontSize(cell.styles.fontSize - 1.2);
                                            doc.setFillColor(bgColor);

                                            const [textWidth, textHeight] = [doc.getTextDimensions(_text).w, doc.getTextDimensions(_text).h];
                                            let [badgeWidth, badgeHeight] = [textWidth + 10, textHeight + 4.5];
                                            if (badgeWidth >= cell.width) {
                                                badgeWidth += textWidth + 3;
                                            }

                                            if (this.pageContentHeight >= cell.y + 1) {
                                                doc.roundedRect(cell.x + ((cell.width - badgeWidth) / 2), cell.y + ((cell.height - badgeHeight) / 2), badgeWidth, badgeHeight, 3, 3, 'F');

                                                // Draw text in the center of the cell
                                                doc.text(_text, cell.x + cell.width / 2, cell.y + (cell.height / 2) + 0.15, {
                                                    baseline: 'middle',
                                                    align: 'center'
                                                });
                                            }
                                        } else if (column.dataKey === 1) {
                                            if (cell.raw.contentType === 'importance' && cell.raw.content) {
                                                // Set text color
                                                doc.setTextColor('#ffffff');
                                                doc.setFontSize(this.report_lang === 'ko' ? cell.styles.fontSize - 1.5 : cell.styles.fontSize - 2);
                                                doc.setFillColor('#1565C0');

                                                const _text = cell.raw.content;
                                                const [textWidth, textHeight] = [doc.getTextDimensions(_text).w, doc.getTextDimensions(_text).h];
                                                let [badgeWidth, badgeHeight] = [textWidth + 10, textHeight + 4.5];
                                                if (badgeWidth >= cell.width) {
                                                    badgeWidth += textWidth + 3;
                                                }

                                                doc.roundedRect(cell.x + ((cell.width - badgeWidth) / 2), cell.y + ((cell.height - badgeHeight) / 2), badgeWidth, badgeHeight, 3, 3, 'F');

                                                // Draw text in the center of the cell
                                                doc.text(_text, cell.x + cell.width / 2, cell.y + (cell.height / 2) + 0.15, {
                                                    baseline: 'middle',
                                                    align: 'center'
                                                });

                                            } else if (cell.raw.contentType === 'content' && cell.raw.content) {
                                                if (this.report_lang === 'ca') {
                                                    cell.styles.font = this.jsPDFOpt.fontFamily_ca;
                                                } else {
                                                    cell.styles.font = this.jsPDFOpt.fontFamily;
                                                }
                                            }
                                        }
                                    }
                                },
                                didDrawPage: (HookData) => {
                                    this.addHeader(HookData.doc);
                                }
                            });

                            this.setFont(doc, null);
                            position_y = doc.lastAutoTable.finalY;

                            // // 문항별 실사의견 테이블
                            // if (_sub.sub_review_comment && /^[\s\W]*$/.test(_sub.sub_review_comment) === false) {
                            //     autoTable(doc, {
                            //         theme: 'grid',
                            //         startY: position_y,
                            //         useCss: true,
                            //         margin: { ...this.jsPDFOpt.margin, top: this.firstElementSpacing - 5 },
                            //         styles: { valign: 'middle' },
                            //         body: [
                            //             [
                            //                 {
                            //                     content: this.$t('평가자 종합 의견', this.report_lang),
                            //                     styles: {
                            //                         ...this.tableStyles.th,
                            //                         fontSize: this.report_lang === "ca" ? 7.8 : 8.5,
                            //                         cellWidth: this.report_lang === "ko" ? 38.7 : 58,
                            //                         halign: 'center',
                            //                         cellPadding: { top: 4, right: 5, bottom: 3.5, left: 5 },
                            //                     }
                            //                 },
                            //                 {
                            //                     content: _sub.sub_review_comment,
                            //                     styles: {
                            //                         ...this.tableStyles.td,
                            //                         cellPadding: { top: 4.5, right: 5, bottom: 3.5, left: 5 }
                            //                     }
                            //                 },
                            //             ]
                            //         ]
                            //     })

                            //     position_y = doc.lastAutoTable.finalY
                            // }

                            position_y += this.jsPDFOpt.spacing.section_xs;
                        });
                    });
                });

                return position_y;
            } catch (error) {
                this.addRenderWarning(doc, '세부 평가결과', error);
            }

        },
        generateFactors() {
            if (!this.scoring?.scoring_pd || !this.scoring.scoring_pd.length) {
                this.factors = [];
            } else {
                let _scoring_pd = this.sortBySubCode([
                    ...this.scoring.scoring_pd.sort((a, b) => {
                        return a.satisfied && !b.satisfied
                            ? -1
                            : !a.satisfied && b.satisfied ? 1 : 0;
                    })
                ]);
                _scoring_pd = _scoring_pd.sort((a, b) => {
                    return a.ev_id > b.ev_id;
                });

                const _lang = this.report_lang;
                let _factors_raw = _scoring_pd.reduce((_factors_v2, _factor) => {
                    if (!_factor.not_applicable && _factor.sub_code) {
                        let {
                            category1_question_code,
                            category1_question_name,
                            category1_question_name_ea,
                            category1_question_name_ca,
                            category3_question_code,
                            category3_question_name,
                            category3_question_name_ea,
                            category3_question_name_ca,
                            sub_code,
                            sub_name,
                            sub_name_ca,
                            sub_name_ea,
                            satisfied,
                            ev_name,
                            ev_name_e,
                            ev_name_c,
                            ev_reverse_name,
                            ev_reverse_name_e,
                            ev_reverse_name_c,
                            ev_importance,
                        } = _factor;

                        let _category1_idx = _factors_v2.findIndex(_factors => _factors.category1_question_code === category1_question_code);
                        const _category1_question_name = _lang === 'ko' ? category1_question_name : _lang === 'en' ? category1_question_name_ea : category1_question_name_ca;
                        if (_category1_idx < 0) {
                            _factors_v2.push({
                                category1_question_code,
                                category1_question_name: _category1_question_name,
                                category3: []
                            });

                            _category1_idx = _factors_v2.findIndex(_factors => _factors.category1_question_code === category1_question_code);
                        }

                        let _category3_idex = _factors_v2[_category1_idx].category3.findIndex(_factors_category3 => _factors_category3.category3_question_code === category3_question_code);
                        if (_category3_idex < 0) {
                            const _category3_question_name = _lang === 'ko' ? category3_question_name : _lang === 'en' ? category3_question_name_ea : category3_question_name_ca;
                            _factors_v2[_category1_idx].category3.push({
                                category3_question_code, category3_question_name: _category3_question_name,
                                subs: []
                            });

                            _category3_idex = _factors_v2[_category1_idx].category3.findIndex(_factors_category3 => _factors_category3.category3_question_code === category3_question_code);
                        }

                        let [
                            _content_ev, , _sub_name,
                            // _content_audit_comment, _content_review_comment
                        ] = new Array(4).fill(null);
                        if (satisfied) {
                            _content_ev = _lang === 'ko' ? ev_name : _lang === 'en' ? ev_name_e : ev_name_c;
                        } else {
                            _content_ev = _lang === 'ko' ? ev_reverse_name : _lang === 'en' ? ev_reverse_name_e : ev_reverse_name_c;
                        }
                        // _content_audit_comment = _lang === "ko" ? audit_comment : _lang === "en" ? audit_comment_ea : audit_comment_ca
                        // _content_review_comment = _lang === "ko" ? review_comment : _lang === "en" ? review_comment_ea : review_comment_ca

                        if (!_content_ev) _content_ev = null;
                        // if (!_content_audit_comment) _content_audit_comment = null
                        // if (!_content_review_comment) _content_review_comment = null

                        _sub_name = _lang === 'ko' ? sub_name : _lang === 'en' ? sub_name_ea : sub_name_ca;
                        if (!_sub_name) _sub_name = null;
                        // if (_content_review_comment && /^[^\p{L}\p{N}]+$/u.test(_content_review_comment) === false) {
                        //     if (this.auditor_shortname_prefix_regexp.test(_content_review_comment)) {
                        //         _content_review_comment = _content_review_comment.replace(this.auditor_shortname_prefix_regexp, '').trim()
                        //     }
                        // }
                        // _content_review_comment = this.isFieldEmpty(_content_review_comment) ? null : _content_review_comment

                        let _sub_index = _factors_v2[_category1_idx].category3[_category3_idex].subs.findIndex((sub) => sub.sub_code === sub_code);
                        if (_sub_index === -1) {
                            _factors_v2[_category1_idx].category3[_category3_idex].subs.push({
                                sub_code,
                                sub_name: _sub_name,
                                evaluations: [],
                                sub_review_comment: null // _content_review_comment
                            });

                            _sub_index = _factors_v2[_category1_idx].category3[_category3_idex].subs.findIndex(({sub_code: _sub_code}) => _sub_code === sub_code);
                        }

                        // if (_content_audit_comment && /^[^\p{L}\p{N}]+$/u.test(_content_audit_comment) === false) {
                        //     if (this.auditor_shortname_prefix_regexp.test(_content_audit_comment)) {
                        //         _content_audit_comment = _content_audit_comment.replace(this.auditor_shortname_prefix_regexp, '').trim()
                        //     }
                        // }
                        // _content_audit_comment = this.isFieldEmpty(_content_audit_comment) ? null : _content_audit_comment

                        if (_content_ev && /^[^\p{L}\p{N}]+$/u.test(_content_ev) === false) {
                            let _evaluation_content = [];
                            const _row_1st = [{
                                content: satisfied ? this.$t('충족', this.report_lang) : this.$t('미충족', this.report_lang),
                                contentType: 'satisfied',
                                // rowSpan: !_content_audit_comment ? 1 : 2,
                                rowSpan: 1,
                                status: satisfied,
                                styles: {}
                            }];
                            if (ev_importance === 'HIGH') {
                                _row_1st.push({
                                    content: this.$t('중요사항', this.report_lang),
                                    contentType: 'importance',
                                    styles: {halign: 'center', valign: 'middle', fillColor: 248}
                                });
                            }
                            _row_1st.push({
                                content: _content_ev,
                                contentType: 'content',
                                styles: this.factorstables.td
                            });
                            _evaluation_content.push(_row_1st);

                            // if (_content_audit_comment) {
                            //     _evaluation_content.push([
                            //         { content: this.$t('항목별 평가자 의견', this.report_lang), styles: { halign: "center", valign: "middle", fillColor: 248, fontSize: this.report_lang === "en" ? this.factorstables.td.fontSize - 0.3 : this.factorstables.td.fontSize } },
                            //         { content: _content_audit_comment, contentType: "assessment" }
                            //     ])
                            // }

                            _factors_v2[_category1_idx].category3[_category3_idex].subs[_sub_index].evaluations.push(..._evaluation_content);
                        }
                    }

                    return _factors_v2;
                }, []);

                for (let _factor_cat1 of _factors_raw) {
                    for (let _factor_cat3 of _factor_cat1.category3) {
                        for (let _factor_subs of _factor_cat3.subs) {
                            const _flatten_sub_evaluations = [..._factor_subs.evaluations].reduce((_flatten, _sub_ev) => {
                                _flatten.push(..._sub_ev);
                                return _flatten;
                            }, []);

                            const _has_importance_evaluation_or_assessment = _flatten_sub_evaluations.some(({contentType}) => ['importance', 'assessment'].includes(contentType));
                            if (_has_importance_evaluation_or_assessment) {
                                for (let _subs_evs of _factor_subs.evaluations) {
                                    let _ev_importance_or_assessment_idx = _subs_evs.findIndex(({contentType}) => contentType && ['importance', 'assessment'].includes(contentType));
                                    if (_ev_importance_or_assessment_idx == -1) {
                                        const _subs_evs_idx = _subs_evs.findIndex(({contentType}) => contentType === 'content');
                                        if (_subs_evs_idx !== -1) {
                                            _subs_evs[_subs_evs_idx].colSpan = 2;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                this.factors = _factors_raw;
            }
        },
        orderCategory1(_category1_scoring, _category1_fieldname) {
            if (!Array.isArray(_category1_scoring)) {
                return this.ordered_cataory1.reduce((_ordered, _category1_name) => {
                    const _category1 = Object.values(_category1_scoring).find(_category1 => _category1[_category1_fieldname] === _category1_name);
                    if (_category1) _ordered.push(_category1);
                    return _ordered;
                }, []);
            } else {
                return this.ordered_cataory1.reduce((_ordered, _category1_name) => {
                    const _category1 = _category1_scoring.find(_category1 => _category1[_category1_fieldname] === _category1_name);
                    if (_category1) _ordered.push(_category1);
                    return _ordered;
                }, []);
            }
        },
        async generatePDF_kia(doc, position_top) {
            if (this.reportMode === 'full') {
                // Factors 페이지 데이터 생성
                this.generateFactors();
            }

            this.pageContentWidth = doc.internal.pageSize.width - (this.jsPDFOpt.margin.left + this.jsPDFOpt.margin.right);
            this.pageContentHeight = doc.internal.pageSize.height - (this.jsPDFOpt.margin.top + this.jsPDFOpt.margin.bottom);

            this.generateCover(doc);

            doc.addPage();
            this.addHeader(doc, 2);

            let position_y = await this.createSummaryPage(doc, position_top);
            position_y = await this.generateRiskandCompliancePage(doc, position_y);
            position_y = this.generatePartialSummaryPage(doc, position_y);
            position_y = await this.createCategory2ScorePage(doc, position_y);
            position_y = await this.generateCategory3AnalysisPage(doc, position_y);

            if (this.reportMode === 'full') {
                this.createFactorsPage(doc, position_y);
            }

            const totalPages = doc.getNumberOfPages();

            for (let i = 2; i <= totalPages; i++) {
                doc.setPage(i);  // 현재 페이지로 이동
                this.addFooter(doc);
            }

            doc.setDocumentProperties({
                title: this.pdf_filename,
                subject: this.pdf_filename,
                filename: `${this.pdf_filename}.pdf`,
                author: 'QuantifiedESG Inc.',
                creator: 'QESG'
            });

            return doc;
        }
    }
};
